//!function(t){function e(){return new Date(Date.UTC.apply(Date,arguments))}var i=function(e,i){var a=this;this.element=t(e),this.language=i.language||this.element.data("date-language")||"en",this.language=this.language in n?this.language:"en",this.isRTL=n[this.language].rtl||"rtl"==t("body").css("direction"),this.formatType=i.formatType||this.element.data("format-type")||"standard",this.format=s.parseFormat(i.format||this.element.data("date-format")||n[this.language].format||s.getDefaultFormat(this.formatType,"input"),this.formatType),this.isInline=!1,this.isVisible=!1,this.isInput=this.element.is("input"),this.component=this.element.is(".date")?this.element.find(".date-set").parent():!1,this.componentReset=this.element.is(".date")?this.element.find(".date-reset").parent():!1,this.hasInput=this.component&&this.element.find("input").length,this.component&&0===this.component.length&&(this.component=!1),this.linkField=i.linkField||this.element.data("link-field")||!1,this.linkFormat=s.parseFormat(i.linkFormat||this.element.data("link-format")||s.getDefaultFormat(this.formatType,"link"),this.formatType),this.minuteStep=i.minuteStep||this.element.data("minute-step")||5,this.pickerPosition=i.pickerPosition||this.element.data("picker-position")||"bottom-right",this.showMeridian=i.showMeridian||this.element.data("show-meridian")||!1,this.initialDate=i.initialDate||new Date,this._attachEvents(),this.formatViewType="datetime","formatViewType"in i?this.formatViewType=i.formatViewType:"formatViewType"in this.element.data()&&(this.formatViewType=this.element.data("formatViewType")),this.minView=0,"minView"in i?this.minView=i.minView:"minView"in this.element.data()&&(this.minView=this.element.data("min-view")),this.minView=s.convertViewMode(this.minView),this.maxView=s.modes.length-1,"maxView"in i?this.maxView=i.maxView:"maxView"in this.element.data()&&(this.maxView=this.element.data("max-view")),this.maxView=s.convertViewMode(this.maxView),this.wheelViewModeNavigation=!1,"wheelViewModeNavigation"in i?this.wheelViewModeNavigation=i.wheelViewModeNavigation:"wheelViewModeNavigation"in this.element.data()&&(this.wheelViewModeNavigation=this.element.data("view-mode-wheel-navigation")),this.wheelViewModeNavigationInverseDirection=!1,"wheelViewModeNavigationInverseDirection"in i?this.wheelViewModeNavigationInverseDirection=i.wheelViewModeNavigationInverseDirection:"wheelViewModeNavigationInverseDirection"in this.element.data()&&(this.wheelViewModeNavigationInverseDirection=this.element.data("view-mode-wheel-navigation-inverse-dir")),this.wheelViewModeNavigationDelay=100,"wheelViewModeNavigationDelay"in i?this.wheelViewModeNavigationDelay=i.wheelViewModeNavigationDelay:"wheelViewModeNavigationDelay"in this.element.data()&&(this.wheelViewModeNavigationDelay=this.element.data("view-mode-wheel-navigation-delay")),this.startViewMode=2,"startView"in i?this.startViewMode=i.startView:"startView"in this.element.data()&&(this.startViewMode=this.element.data("start-view")),this.startViewMode=s.convertViewMode(this.startViewMode),this.viewMode=this.startViewMode,this.viewSelect=this.minView,"viewSelect"in i?this.viewSelect=i.viewSelect:"viewSelect"in this.element.data()&&(this.viewSelect=this.element.data("view-select")),this.viewSelect=s.convertViewMode(this.viewSelect),this.forceParse=!0,"forceParse"in i?this.forceParse=i.forceParse:"dateForceParse"in this.element.data()&&(this.forceParse=this.element.data("date-force-parse")),this.picker=t(s.template).appendTo(this.isInline?this.element:"body").on({click:t.proxy(this.click,this),mousedown:t.proxy(this.mousedown,this)}),this.wheelViewModeNavigation&&(t.fn.mousewheel?this.picker.on({mousewheel:t.proxy(this.mousewheel,this)}):console.log("Mouse Wheel event is not supported. Please include the jQuery Mouse Wheel plugin before enabling this option")),this.isInline?this.picker.addClass("datetimepicker-inline"):this.picker.addClass("datetimepicker-dropdown-"+this.pickerPosition+" dropdown-menu"),this.isRTL&&(this.picker.addClass("datetimepicker-rtl"),this.picker.find(".prev i, .next i").toggleClass("fa-arrow-left fa-arrow-right")),t(document).on("mousedown",function(e){0===t(e.target).closest(".datetimepicker").length&&a.hide()}),this.autoclose=!1,"autoclose"in i?this.autoclose=i.autoclose:"dateAutoclose"in this.element.data()&&(this.autoclose=this.element.data("date-autoclose")),this.keyboardNavigation=!0,"keyboardNavigation"in i?this.keyboardNavigation=i.keyboardNavigation:"dateKeyboardNavigation"in this.element.data()&&(this.keyboardNavigation=this.element.data("date-keyboard-navigation")),this.todayBtn=i.todayBtn||this.element.data("date-today-btn")||!1,this.todayHighlight=i.todayHighlight||this.element.data("date-today-highlight")||!1,this.weekStart=(i.weekStart||this.element.data("date-weekstart")||n[this.language].weekStart||0)%7,this.weekEnd=(this.weekStart+6)%7,this.startDate=-1/0,this.endDate=1/0,this.daysOfWeekDisabled=[],this.setStartDate(i.startDate||this.element.data("date-startdate")),this.setEndDate(i.endDate||this.element.data("date-enddate")),this.setDaysOfWeekDisabled(i.daysOfWeekDisabled||this.element.data("date-days-of-week-disabled")),this.fillDow(),this.fillMonths(),this.update(),this.showMode(),this.isInline&&this.show()};i.prototype={constructor:i,_events:[],_attachEvents:function(){this._detachEvents(),this.isInput?this._events=[[this.element,{focus:t.proxy(this.show,this),keyup:t.proxy(this.update,this),keydown:t.proxy(this.keydown,this)}]]:this.component&&this.hasInput?(this._events=[[this.element.find("input"),{focus:t.proxy(this.show,this),keyup:t.proxy(this.update,this),keydown:t.proxy(this.keydown,this)}],[this.component,{click:t.proxy(this.show,this)}]],this.componentReset&&this._events.push([this.componentReset,{click:t.proxy(this.reset,this)}])):this.element.is("div")?this.isInline=!0:this._events=[[this.element,{click:t.proxy(this.show,this)}]];for(var e,i,n=0;n<this._events.length;n++)e=this._events[n][0],i=this._events[n][1],e.on(i)},_detachEvents:function(){for(var t,e,i=0;i<this._events.length;i++)t=this._events[i][0],e=this._events[i][1],t.off(e);this._events=[]},show:function(e){this.picker.show(),this.height=this.component?this.component.outerHeight():this.element.outerHeight(),this.forceParse&&this.update(),this.place(),t(window).on("resize",t.proxy(this.place,this)),e&&(e.stopPropagation(),e.preventDefault()),this.isVisible=!0,this.element.trigger({type:"show",date:this.date})},hide:function(){this.isVisible&&(this.isInline||(this.picker.hide(),t(window).off("resize",this.place),this.viewMode=this.startViewMode,this.showMode(),this.isInput||t(document).off("mousedown",this.hide),this.forceParse&&(this.isInput&&this.element.val()||this.hasInput&&this.element.find("input").val())&&this.setValue(),this.isVisible=!1,this.element.trigger({type:"hide",date:this.date})))},remove:function(){this._detachEvents(),this.picker.remove(),delete this.picker,delete this.element.data().datetimepicker},getDate:function(){var t=this.getUTCDate();return new Date(t.getTime()+6e4*t.getTimezoneOffset())},getUTCDate:function(){return this.date},setDate:function(t){this.setUTCDate(new Date(t.getTime()-6e4*t.getTimezoneOffset()))},setUTCDate:function(t){t>=this.startDate&&t<=this.endDate?(this.date=t,this.setValue(),this.viewDate=this.date,this.fill()):this.element.trigger({type:"outOfRange",date:t,startDate:this.startDate,endDate:this.endDate})},setFormat:function(t){this.format=s.parseFormat(t,this.formatType);var e;this.isInput?e=this.element:this.component&&(e=this.element.find("input")),e&&e.val()&&this.setValue()},setValue:function(){var e=this.getFormattedDate();this.isInput?this.element.val(e):(this.component&&this.element.find("input").val(e),this.element.data("date",e)),this.linkField&&t("#"+this.linkField).val(this.getFormattedDate(this.linkFormat))},getFormattedDate:function(t){return void 0==t&&(t=this.format),s.formatDate(this.date,t,this.language,this.formatType)},setStartDate:function(t){this.startDate=t||-1/0,this.startDate!==-1/0&&(this.startDate=s.parseDate(this.startDate,this.format,this.language,this.formatType)),this.update(),this.updateNavArrows()},setEndDate:function(t){this.endDate=t||1/0,1/0!==this.endDate&&(this.endDate=s.parseDate(this.endDate,this.format,this.language,this.formatType)),this.update(),this.updateNavArrows()},setDaysOfWeekDisabled:function(e){this.daysOfWeekDisabled=e||[],t.isArray(this.daysOfWeekDisabled)||(this.daysOfWeekDisabled=this.daysOfWeekDisabled.split(/,\s*/)),this.daysOfWeekDisabled=t.map(this.daysOfWeekDisabled,function(t){return parseInt(t,10)}),this.update(),this.updateNavArrows()},place:function(){if(!this.isInline){var e,i,n,s=parseInt(this.element.parents().filter(function(){return"auto"!=t(this).css("z-index")}).first().css("z-index"))+10;this.component?(e=this.component.offset(),n=e.left,("bottom-left"==this.pickerPosition||"top-left"==this.pickerPosition)&&(n+=this.component.outerWidth()-this.picker.outerWidth())):(e=this.element.offset(),n=e.left),i="top-left"==this.pickerPosition||"top-right"==this.pickerPosition?e.top-this.picker.outerHeight():e.top+this.height,this.picker.css({top:i,left:n,zIndex:s})}},update:function(){var t,e=!1;arguments&&arguments.length&&("string"==typeof arguments[0]||arguments[0]instanceof Date)?(t=arguments[0],e=!0):t=this.element.data("date")||(this.isInput?this.element.val():this.element.find("input").val())||this.initialDate,t||(t=new Date,e=!1),this.date=s.parseDate(t,this.format,this.language,this.formatType),e&&this.setValue(),this.viewDate=this.date<this.startDate?new Date(this.startDate):this.date>this.endDate?new Date(this.endDate):new Date(this.date),this.fill()},fillDow:function(){for(var t=this.weekStart,e="<tr>";t<this.weekStart+7;)e+='<th class="dow">'+n[this.language].daysMin[t++%7]+"</th>";e+="</tr>",this.picker.find(".datetimepicker-days thead").append(e)},fillMonths:function(){for(var t="",e=0;12>e;)t+='<span class="month">'+n[this.language].monthsShort[e++]+"</span>";this.picker.find(".datetimepicker-months td").html(t)},fill:function(){if(null!=this.date&&null!=this.viewDate){var i=new Date(this.viewDate),a=i.getUTCFullYear(),o=i.getUTCMonth(),r=i.getUTCDate(),l=i.getUTCHours(),c=i.getUTCMinutes(),d=this.startDate!==-1/0?this.startDate.getUTCFullYear():-1/0,h=this.startDate!==-1/0?this.startDate.getUTCMonth():-1/0,u=1/0!==this.endDate?this.endDate.getUTCFullYear():1/0,p=1/0!==this.endDate?this.endDate.getUTCMonth():1/0,f=new e(this.date.getUTCFullYear(),this.date.getUTCMonth(),this.date.getUTCDate()).valueOf(),g=new Date;if(this.picker.find(".datetimepicker-days thead th:eq(1)").text(n[this.language].months[o]+" "+a),"time"==this.formatViewType){var v=l%12?l%12:12,m=(10>v?"0":"")+v,b=(10>c?"0":"")+c,w=n[this.language].meridiem[12>l?0:1];this.picker.find(".datetimepicker-hours thead th:eq(1)").text(m+":"+b+" "+w.toUpperCase()),this.picker.find(".datetimepicker-minutes thead th:eq(1)").text(m+":"+b+" "+w.toUpperCase())}else this.picker.find(".datetimepicker-hours thead th:eq(1)").text(r+" "+n[this.language].months[o]+" "+a),this.picker.find(".datetimepicker-minutes thead th:eq(1)").text(r+" "+n[this.language].months[o]+" "+a);this.picker.find("tfoot th.today").text(n[this.language].today).toggle(this.todayBtn!==!1),this.updateNavArrows(),this.fillMonths();var y=e(a,o-1,28,0,0,0,0),x=s.getDaysInMonth(y.getUTCFullYear(),y.getUTCMonth());y.setUTCDate(x),y.setUTCDate(x-(y.getUTCDay()-this.weekStart+7)%7);var T=new Date(y);T.setUTCDate(T.getUTCDate()+42),T=T.valueOf();for(var C,S=[];y.valueOf()<T;)y.getUTCDay()==this.weekStart&&S.push("<tr>"),C="",y.getUTCFullYear()<a||y.getUTCFullYear()==a&&y.getUTCMonth()<o?C+=" old":(y.getUTCFullYear()>a||y.getUTCFullYear()==a&&y.getUTCMonth()>o)&&(C+=" new"),this.todayHighlight&&y.getUTCFullYear()==g.getFullYear()&&y.getUTCMonth()==g.getMonth()&&y.getUTCDate()==g.getDate()&&(C+=" today"),y.valueOf()==f&&(C+=" active"),(y.valueOf()+864e5<=this.startDate||y.valueOf()>this.endDate||-1!==t.inArray(y.getUTCDay(),this.daysOfWeekDisabled))&&(C+=" disabled"),S.push('<td class="day'+C+'">'+y.getUTCDate()+"</td>"),y.getUTCDay()==this.weekEnd&&S.push("</tr>"),y.setUTCDate(y.getUTCDate()+1);this.picker.find(".datetimepicker-days tbody").empty().append(S.join("")),S=[];for(var k="",_="",$="",D=0;24>D;D++){var I=e(a,o,r,D);C="",I.valueOf()+36e5<=this.startDate||I.valueOf()>this.endDate?C+=" disabled":l==D&&(C+=" active"),this.showMeridian&&2==n[this.language].meridiem.length?(_=12>D?n[this.language].meridiem[0]:n[this.language].meridiem[1],_!=$&&(""!=$&&S.push("</fieldset>"),S.push('<fieldset class="hour"><legend>'+_.toUpperCase()+"</legend>")),$=_,k=D%12?D%12:12,S.push('<span class="hour'+C+" hour_"+(12>D?"am":"pm")+'">'+k+"</span>"),23==D&&S.push("</fieldset>")):(k=D+":00",S.push('<span class="hour'+C+'">'+k+"</span>"))}this.picker.find(".datetimepicker-hours td").html(S.join("")),S=[],k="",_="",$="";for(var D=0;60>D;D+=this.minuteStep){var I=e(a,o,r,l,D,0);C="",I.valueOf()<this.startDate||I.valueOf()>this.endDate?C+=" disabled":Math.floor(c/this.minuteStep)==Math.floor(D/this.minuteStep)&&(C+=" active"),this.showMeridian&&2==n[this.language].meridiem.length?(_=12>l?n[this.language].meridiem[0]:n[this.language].meridiem[1],_!=$&&(""!=$&&S.push("</fieldset>"),S.push('<fieldset class="minute"><legend>'+_.toUpperCase()+"</legend>")),$=_,k=l%12?l%12:12,S.push('<span class="minute'+C+'">'+k+":"+(10>D?"0"+D:D)+"</span>"),59==D&&S.push("</fieldset>")):(k=D+":00",S.push('<span class="minute'+C+'">'+l+":"+(10>D?"0"+D:D)+"</span>"))}this.picker.find(".datetimepicker-minutes td").html(S.join(""));var M=this.date.getUTCFullYear(),E=this.picker.find(".datetimepicker-months").find("th:eq(1)").text(a).end().find("span").removeClass("active");M==a&&E.eq(this.date.getUTCMonth()).addClass("active"),(d>a||a>u)&&E.addClass("disabled"),a==d&&E.slice(0,h).addClass("disabled"),a==u&&E.slice(p+1).addClass("disabled"),S="",a=10*parseInt(a/10,10);var A=this.picker.find(".datetimepicker-years").find("th:eq(1)").text(a+"-"+(a+9)).end().find("td");a-=1;for(var D=-1;11>D;D++)S+='<span class="year'+(-1==D||10==D?" old":"")+(M==a?" active":"")+(d>a||a>u?" disabled":"")+'">'+a+"</span>",a+=1;A.html(S),this.place()}},updateNavArrows:function(){var t=new Date(this.viewDate),e=t.getUTCFullYear(),i=t.getUTCMonth(),n=t.getUTCDate(),s=t.getUTCHours();switch(this.viewMode){case 0:this.startDate!==-1/0&&e<=this.startDate.getUTCFullYear()&&i<=this.startDate.getUTCMonth()&&n<=this.startDate.getUTCDate()&&s<=this.startDate.getUTCHours()?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),1/0!==this.endDate&&e>=this.endDate.getUTCFullYear()&&i>=this.endDate.getUTCMonth()&&n>=this.endDate.getUTCDate()&&s>=this.endDate.getUTCHours()?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"});break;case 1:this.startDate!==-1/0&&e<=this.startDate.getUTCFullYear()&&i<=this.startDate.getUTCMonth()&&n<=this.startDate.getUTCDate()?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),1/0!==this.endDate&&e>=this.endDate.getUTCFullYear()&&i>=this.endDate.getUTCMonth()&&n>=this.endDate.getUTCDate()?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"});break;case 2:this.startDate!==-1/0&&e<=this.startDate.getUTCFullYear()&&i<=this.startDate.getUTCMonth()?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),1/0!==this.endDate&&e>=this.endDate.getUTCFullYear()&&i>=this.endDate.getUTCMonth()?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"});break;case 3:case 4:this.startDate!==-1/0&&e<=this.startDate.getUTCFullYear()?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),1/0!==this.endDate&&e>=this.endDate.getUTCFullYear()?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"})}},mousewheel:function(e){if(e.preventDefault(),e.stopPropagation(),!this.wheelPause){this.wheelPause=!0;var i=e.originalEvent,n=i.wheelDelta,s=n>0?1:0===n?0:-1;this.wheelViewModeNavigationInverseDirection&&(s=-s),this.showMode(s),setTimeout(t.proxy(function(){this.wheelPause=!1},this),this.wheelViewModeNavigationDelay)}},click:function(i){i.stopPropagation(),i.preventDefault();var n=t(i.target).closest("span, td, th, legend");if(1==n.length){if(n.is(".disabled"))return this.element.trigger({type:"outOfRange",date:this.viewDate,startDate:this.startDate,endDate:this.endDate}),void 0;switch(n[0].nodeName.toLowerCase()){case"th":switch(n[0].className){case"switch":this.showMode(1);break;case"prev":case"next":var a=s.modes[this.viewMode].navStep*("prev"==n[0].className?-1:1);switch(this.viewMode){case 0:this.viewDate=this.moveHour(this.viewDate,a);break;case 1:this.viewDate=this.moveDate(this.viewDate,a);break;case 2:this.viewDate=this.moveMonth(this.viewDate,a);break;case 3:case 4:this.viewDate=this.moveYear(this.viewDate,a)}this.fill();break;case"today":var o=new Date;o=e(o.getFullYear(),o.getMonth(),o.getDate(),o.getHours(),o.getMinutes(),o.getSeconds(),0),this.viewMode=this.startViewMode,this.showMode(0),this._setDate(o),this.fill(),this.autoclose&&this.hide()}break;case"span":if(!n.is(".disabled")){var r=this.viewDate.getUTCFullYear(),l=this.viewDate.getUTCMonth(),c=this.viewDate.getUTCDate(),d=this.viewDate.getUTCHours(),h=this.viewDate.getUTCMinutes(),u=this.viewDate.getUTCSeconds();if(n.is(".month")?(this.viewDate.setUTCDate(1),l=n.parent().find("span").index(n),c=this.viewDate.getUTCDate(),this.viewDate.setUTCMonth(l),this.element.trigger({type:"changeMonth",date:this.viewDate}),this.viewSelect>=3&&this._setDate(e(r,l,c,d,h,u,0))):n.is(".year")?(this.viewDate.setUTCDate(1),r=parseInt(n.text(),10)||0,this.viewDate.setUTCFullYear(r),this.element.trigger({type:"changeYear",date:this.viewDate}),this.viewSelect>=4&&this._setDate(e(r,l,c,d,h,u,0))):n.is(".hour")?(d=parseInt(n.text(),10)||0,(n.hasClass("hour_am")||n.hasClass("hour_pm"))&&(12==d&&n.hasClass("hour_am")?d=0:12!=d&&n.hasClass("hour_pm")&&(d+=12)),this.viewDate.setUTCHours(d),this.element.trigger({type:"changeHour",date:this.viewDate}),this.viewSelect>=1&&this._setDate(e(r,l,c,d,h,u,0))):n.is(".minute")&&(h=parseInt(n.text().substr(n.text().indexOf(":")+1),10)||0,this.viewDate.setUTCMinutes(h),this.element.trigger({type:"changeMinute",date:this.viewDate}),this.viewSelect>=0&&this._setDate(e(r,l,c,d,h,u,0))),0!=this.viewMode){var p=this.viewMode;this.showMode(-1),this.fill(),p==this.viewMode&&this.autoclose&&this.hide()}else this.fill(),this.autoclose&&this.hide()}break;case"td":if(n.is(".day")&&!n.is(".disabled")){var c=parseInt(n.text(),10)||1,r=this.viewDate.getUTCFullYear(),l=this.viewDate.getUTCMonth(),d=this.viewDate.getUTCHours(),h=this.viewDate.getUTCMinutes(),u=this.viewDate.getUTCSeconds();n.is(".old")?0===l?(l=11,r-=1):l-=1:n.is(".new")&&(11==l?(l=0,r+=1):l+=1),this.viewDate.setUTCFullYear(r),this.viewDate.setUTCMonth(l),this.viewDate.setUTCDate(c),this.element.trigger({type:"changeDay",date:this.viewDate}),this.viewSelect>=2&&this._setDate(e(r,l,c,d,h,u,0))}var p=this.viewMode;this.showMode(-1),this.fill(),p==this.viewMode&&this.autoclose&&this.hide()}}},_setDate:function(t,e){e&&"date"!=e||(this.date=t),e&&"view"!=e||(this.viewDate=t),this.fill(),this.setValue();var i;this.isInput?i=this.element:this.component&&(i=this.element.find("input")),i&&(i.change(),this.autoclose&&(!e||"date"==e)),this.element.trigger({type:"changeDate",date:this.date})},moveMinute:function(t,e){if(!e)return t;var i=new Date(t.valueOf());return i.setUTCMinutes(i.getUTCMinutes()+e*this.minuteStep),i},moveHour:function(t,e){if(!e)return t;var i=new Date(t.valueOf());return i.setUTCHours(i.getUTCHours()+e),i},moveDate:function(t,e){if(!e)return t;var i=new Date(t.valueOf());return i.setUTCDate(i.getUTCDate()+e),i},moveMonth:function(t,e){if(!e)return t;var i,n,s=new Date(t.valueOf()),a=s.getUTCDate(),o=s.getUTCMonth(),r=Math.abs(e);if(e=e>0?1:-1,1==r)n=-1==e?function(){return s.getUTCMonth()==o}:function(){return s.getUTCMonth()!=i},i=o+e,s.setUTCMonth(i),(0>i||i>11)&&(i=(i+12)%12);else{for(var l=0;r>l;l++)s=this.moveMonth(s,e);i=s.getUTCMonth(),s.setUTCDate(a),n=function(){return i!=s.getUTCMonth()}}for(;n();)s.setUTCDate(--a),s.setUTCMonth(i);return s},moveYear:function(t,e){return this.moveMonth(t,12*e)},dateWithinRange:function(t){return t>=this.startDate&&t<=this.endDate},keydown:function(t){if(this.picker.is(":not(:visible)"))return 27==t.keyCode&&this.show(),void 0;var e,i,n,s=!1;switch(t.keyCode){case 27:this.hide(),t.preventDefault();break;case 37:case 39:if(!this.keyboardNavigation)break;e=37==t.keyCode?-1:1,viewMode=this.viewMode,t.ctrlKey?viewMode+=2:t.shiftKey&&(viewMode+=1),4==viewMode?(i=this.moveYear(this.date,e),n=this.moveYear(this.viewDate,e)):3==viewMode?(i=this.moveMonth(this.date,e),n=this.moveMonth(this.viewDate,e)):2==viewMode?(i=this.moveDate(this.date,e),n=this.moveDate(this.viewDate,e)):1==viewMode?(i=this.moveHour(this.date,e),n=this.moveHour(this.viewDate,e)):0==viewMode&&(i=this.moveMinute(this.date,e),n=this.moveMinute(this.viewDate,e)),this.dateWithinRange(i)&&(this.date=i,this.viewDate=n,this.setValue(),this.update(),t.preventDefault(),s=!0);break;case 38:case 40:if(!this.keyboardNavigation)break;e=38==t.keyCode?-1:1,viewMode=this.viewMode,t.ctrlKey?viewMode+=2:t.shiftKey&&(viewMode+=1),4==viewMode?(i=this.moveYear(this.date,e),n=this.moveYear(this.viewDate,e)):3==viewMode?(i=this.moveMonth(this.date,e),n=this.moveMonth(this.viewDate,e)):2==viewMode?(i=this.moveDate(this.date,7*e),n=this.moveDate(this.viewDate,7*e)):1==viewMode?this.showMeridian?(i=this.moveHour(this.date,6*e),n=this.moveHour(this.viewDate,6*e)):(i=this.moveHour(this.date,4*e),n=this.moveHour(this.viewDate,4*e)):0==viewMode&&(i=this.moveMinute(this.date,4*e),n=this.moveMinute(this.viewDate,4*e)),this.dateWithinRange(i)&&(this.date=i,this.viewDate=n,this.setValue(),this.update(),t.preventDefault(),s=!0);break;case 13:if(0!=this.viewMode){var a=this.viewMode;this.showMode(-1),this.fill(),a==this.viewMode&&this.autoclose&&this.hide()}else this.fill(),this.autoclose&&this.hide();t.preventDefault();break;case 9:this.hide()}if(s){var o;this.isInput?o=this.element:this.component&&(o=this.element.find("input")),o&&o.change(),this.element.trigger({type:"changeDate",date:this.date})}},showMode:function(t){if(t){var e=Math.max(0,Math.min(s.modes.length-1,this.viewMode+t));e>=this.minView&&e<=this.maxView&&(this.element.trigger({type:"changeMode",date:this.viewDate,oldViewMode:this.viewMode,newViewMode:e}),this.viewMode=e)}this.picker.find(">div").hide().filter(".datetimepicker-"+s.modes[this.viewMode].clsName).css("display","block"),this.updateNavArrows()},reset:function(){this._setDate(null,"date")}},t.fn.datetimepicker=function(e){var n=Array.apply(null,arguments);return n.shift(),this.each(function(){var s=t(this),a=s.data("datetimepicker"),o="object"==typeof e&&e;a||s.data("datetimepicker",a=new i(this,t.extend({},t.fn.datetimepicker.defaults,o))),"string"==typeof e&&"function"==typeof a[e]&&a[e].apply(a,n)})},t.fn.datetimepicker.defaults={},t.fn.datetimepicker.Constructor=i;var n=t.fn.datetimepicker.dates={en:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sun"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa","Su"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],meridiem:["am","pm"],suffix:["st","nd","rd","th"],today:"Today"}},s={modes:[{clsName:"minutes",navFnc:"Hours",navStep:1},{clsName:"hours",navFnc:"Date",navStep:1},{clsName:"days",navFnc:"Month",navStep:1},{clsName:"months",navFnc:"FullYear",navStep:1},{clsName:"years",navFnc:"FullYear",navStep:10}],isLeapYear:function(t){return 0===t%4&&0!==t%100||0===t%400},getDaysInMonth:function(t,e){return[31,s.isLeapYear(t)?29:28,31,30,31,30,31,31,30,31,30,31][e]},getDefaultFormat:function(t,e){if("standard"==t)return"input"==e?"yyyy-mm-dd hh:ii":"yyyy-mm-dd hh:ii:ss";if("php"==t)return"input"==e?"Y-m-d H:i":"Y-m-d H:i:s";throw new Error("Invalid format type.")},validParts:function(t){if("standard"==t)return/hh?|HH?|p|P|ii?|ss?|dd?|DD?|mm?|MM?|yy(?:yy)?/g;if("php"==t)return/[dDjlNwzFmMnStyYaABgGhHis]/g;throw new Error("Invalid format type.")},nonpunctuation:/[^ -\/:-@\[-`{-~\t\n\rTZ]+/g,parseFormat:function(t,e){var i=t.replace(this.validParts(e),"\0").split("\0"),n=t.match(this.validParts(e));if(!i||!i.length||!n||0==n.length)throw new Error("Invalid date format.");return{separators:i,parts:n}},parseDate:function(s,a,o,r){if(s instanceof Date){var l=new Date(s.valueOf()-6e4*s.getTimezoneOffset());return l.setMilliseconds(0),l}if(/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(s)&&(a=this.parseFormat("yyyy-mm-dd",r)),/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}$/.test(s)&&(a=this.parseFormat("yyyy-mm-dd hh:ii",r)),/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}\:\d{1,2}[Z]{0,1}$/.test(s)&&(a=this.parseFormat("yyyy-mm-dd hh:ii:ss",r)),/^[-+]\d+[dmwy]([\s,]+[-+]\d+[dmwy])*$/.test(s)){var c,d,h=/([-+]\d+)([dmwy])/,u=s.match(/([-+]\d+)([dmwy])/g);s=new Date;for(var p=0;p<u.length;p++)switch(c=h.exec(u[p]),d=parseInt(c[1]),c[2]){case"d":s.setUTCDate(s.getUTCDate()+d);break;case"m":s=i.prototype.moveMonth.call(i.prototype,s,d);break;case"w":s.setUTCDate(s.getUTCDate()+7*d);break;case"y":s=i.prototype.moveYear.call(i.prototype,s,d)}return e(s.getUTCFullYear(),s.getUTCMonth(),s.getUTCDate(),s.getUTCHours(),s.getUTCMinutes(),s.getUTCSeconds(),0)}var f,g,c,u=s&&s.match(this.nonpunctuation)||[],s=new Date(0,0,0,0,0,0,0),v={},m=["hh","h","ii","i","ss","s","yyyy","yy","M","MM","m","mm","D","DD","d","dd","H","HH","p","P"],b={hh:function(t,e){return t.setUTCHours(e)},h:function(t,e){return t.setUTCHours(e)},HH:function(t,e){return t.setUTCHours(12==e?0:e)},H:function(t,e){return t.setUTCHours(12==e?0:e)},ii:function(t,e){return t.setUTCMinutes(e)},i:function(t,e){return t.setUTCMinutes(e)},ss:function(t,e){return t.setUTCSeconds(e)},s:function(t,e){return t.setUTCSeconds(e)},yyyy:function(t,e){return t.setUTCFullYear(e)},yy:function(t,e){return t.setUTCFullYear(2e3+e)},m:function(t,e){for(e-=1;0>e;)e+=12;for(e%=12,t.setUTCMonth(e);t.getUTCMonth()!=e;)t.setUTCDate(t.getUTCDate()-1);return t},d:function(t,e){return t.setUTCDate(e)},p:function(t,e){return t.setUTCHours(1==e?t.getUTCHours()+12:t.getUTCHours())}};if(b.M=b.MM=b.mm=b.m,b.dd=b.d,b.P=b.p,s=e(s.getFullYear(),s.getMonth(),s.getDate(),s.getHours(),s.getMinutes(),s.getSeconds()),u.length==a.parts.length){for(var p=0,w=a.parts.length;w>p;p++){if(f=parseInt(u[p],10),c=a.parts[p],isNaN(f))switch(c){case"MM":g=t(n[o].months).filter(function(){var t=this.slice(0,u[p].length),e=u[p].slice(0,t.length);return t==e}),f=t.inArray(g[0],n[o].months)+1;break;case"M":g=t(n[o].monthsShort).filter(function(){var t=this.slice(0,u[p].length),e=u[p].slice(0,t.length);return t==e}),f=t.inArray(g[0],n[o].monthsShort)+1;break;case"p":case"P":f=t.inArray(u[p].toLowerCase(),n[o].meridiem)}v[c]=f}for(var y,p=0;p<m.length;p++)y=m[p],y in v&&!isNaN(v[y])&&b[y](s,v[y])}return s},formatDate:function(e,i,a,o){if(null==e)return"";var r;if("standard"==o)r={yy:e.getUTCFullYear().toString().substring(2),yyyy:e.getUTCFullYear(),m:e.getUTCMonth()+1,M:n[a].monthsShort[e.getUTCMonth()],MM:n[a].months[e.getUTCMonth()],d:e.getUTCDate(),D:n[a].daysShort[e.getUTCDay()],DD:n[a].days[e.getUTCDay()],p:2==n[a].meridiem.length?n[a].meridiem[e.getUTCHours()<12?0:1]:"",h:e.getUTCHours(),i:e.getUTCMinutes(),s:e.getUTCSeconds()},r.H=0==r.h%12?12:r.h%12,r.HH=(r.H<10?"0":"")+r.H,r.P=r.p.toUpperCase(),r.hh=(r.h<10?"0":"")+r.h,r.ii=(r.i<10?"0":"")+r.i,r.ss=(r.s<10?"0":"")+r.s,r.dd=(r.d<10?"0":"")+r.d,r.mm=(r.m<10?"0":"")+r.m;else{if("php"!=o)throw new Error("Invalid format type.");r={y:e.getUTCFullYear().toString().substring(2),Y:e.getUTCFullYear(),F:n[a].months[e.getUTCMonth()],M:n[a].monthsShort[e.getUTCMonth()],n:e.getUTCMonth()+1,t:s.getDaysInMonth(e.getUTCFullYear(),e.getUTCMonth()),j:e.getUTCDate(),l:n[a].days[e.getUTCDay()],D:n[a].daysShort[e.getUTCDay()],w:e.getUTCDay(),N:0==e.getUTCDay()?7:e.getUTCDay(),S:e.getUTCDate()%10<=n[a].suffix.length?n[a].suffix[e.getUTCDate()%10-1]:"",a:2==n[a].meridiem.length?n[a].meridiem[e.getUTCHours()<12?0:1]:"",g:0==e.getUTCHours()%12?12:e.getUTCHours()%12,G:e.getUTCHours(),i:e.getUTCMinutes(),s:e.getUTCSeconds()},r.m=(r.n<10?"0":"")+r.n,r.d=(r.j<10?"0":"")+r.j,r.A=r.a.toString().toUpperCase(),r.h=(r.g<10?"0":"")+r.g,r.H=(r.G<10?"0":"")+r.G,r.i=(r.i<10?"0":"")+r.i,r.s=(r.s<10?"0":"")+r.s}for(var e=[],l=t.extend([],i.separators),c=0,d=i.parts.length;d>c;c++)l.length&&e.push(l.shift()),e.push(r[i.parts[c]]);return e.join("")},convertViewMode:function(t){switch(t){case 4:case"decade":t=4;break;case 3:case"year":t=3;break;case 2:case"month":t=2;break;case 1:case"day":t=1;break;case 0:case"hour":t=0}return t},headTemplate:'<thead><tr><th class="prev"><i class="fa fa-angle-left"/></th><th colspan="5" class="switch"></th><th class="next"><i class="fa fa-angle-right"/></th></tr></thead>',contTemplate:'<tbody><tr><td colspan="7"></td></tr></tbody>',footTemplate:'<tfoot><tr><th colspan="7" class="today"></th></tr></tfoot>'};s.template='<div class="datetimepicker"><div class="datetimepicker-minutes"><table class=" table-condensed">'+s.headTemplate+s.contTemplate+s.footTemplate+"</table>"+"</div>"+'<div class="datetimepicker-hours">'+'<table class=" table-condensed">'+s.headTemplate+s.contTemplate+s.footTemplate+"</table>"+"</div>"+'<div class="datetimepicker-days">'+'<table class=" table-condensed">'+s.headTemplate+"<tbody></tbody>"+s.footTemplate+"</table>"+"</div>"+'<div class="datetimepicker-months">'+'<table class="table-condensed">'+s.headTemplate+s.contTemplate+s.footTemplate+"</table>"+"</div>"+'<div class="datetimepicker-years">'+'<table class="table-condensed">'+s.headTemplate+s.contTemplate+s.footTemplate+"</table>"+"</div>"+"</div>",t.fn.datetimepicker.DPGlobal=s,t.fn.datetimepicker.noConflict=function(){return t.fn.datetimepicker=old,this},t(document).on("focus.datetimepicker.data-api click.datetimepicker.data-api",'[data-provide="datetimepicker"]',function(e){var i=t(this);i.data("datetimepicker")||(e.preventDefault(),i.datetimepicker("show"))}),t(function(){t('[data-provide="datetimepicker-inline"]').datetimepicker()})}(window.jQuery);

/*! version : 4.17.37
 =========================================================
 bootstrap-datetimejs
 https://github.com/Eonasdan/bootstrap-datetimepicker
 Copyright (c) 2015 Jonathan Peterson
 =========================================================
 */
/*
!function (a) { "use strict"; if ("function" == typeof define && define.amd) define(["jquery", "moment"], a); else if ("object" == typeof exports) a(require("jquery"), require("moment")); else { if ("undefined" == typeof jQuery) throw "bootstrap-datetimepicker requires jQuery to be loaded first"; if ("undefined" == typeof moment) throw "bootstrap-datetimepicker requires Moment.js to be loaded first"; a(jQuery, moment) } }(function (a, b) {
	"use strict"; if (!b) throw new Error("bootstrap-datetimepicker requires Moment.js to be loaded first"); var c = function (c, d) {
		var e, f, g, h, i, j, k, l = {}, m = !0, n = !1, o = !1, p = 0, q = [{ clsName: "days", navFnc: "M", navStep: 1 }, { clsName: "months", navFnc: "y", navStep: 1 }, { clsName: "years", navFnc: "y", navStep: 10 }, { clsName: "decades", navFnc: "y", navStep: 100 }], r = ["days", "months", "years", "decades"], s = ["top", "bottom", "auto"], t = ["left", "right", "auto"], u = ["default", "top", "bottom"], v = { up: 38, 38: "up", down: 40, 40: "down", left: 37, 37: "left", right: 39, 39: "right", tab: 9, 9: "tab", escape: 27, 27: "escape", enter: 13, 13: "enter", pageUp: 33, 33: "pageUp", pageDown: 34, 34: "pageDown", shift: 16, 16: "shift", control: 17, 17: "control", space: 32, 32: "space", t: 84, 84: "t", "delete": 46, 46: "delete" }, w = {}, x = function (a) { var c, e, f, g, h, i = !1; return void 0 !== b.tz && void 0 !== d.timeZone && null !== d.timeZone && "" !== d.timeZone && (i = !0), void 0 === a || null === a ? c = i ? b().tz(d.timeZone).startOf("d") : b().startOf("d") : i ? (e = b().tz(d.timeZone).utcOffset(), f = b(a, j, d.useStrict).utcOffset(), f !== e ? (g = b().tz(d.timeZone).format("Z"), h = b(a, j, d.useStrict).format("YYYY-MM-DD[T]HH:mm:ss") + g, c = b(h, j, d.useStrict).tz(d.timeZone)) : c = b(a, j, d.useStrict).tz(d.timeZone)) : c = b(a, j, d.useStrict), c }, y = function (a) { if ("string" != typeof a || a.length > 1) throw new TypeError("isEnabled expects a single character string parameter"); switch (a) { case "y": return -1 !== i.indexOf("Y"); case "M": return -1 !== i.indexOf("M"); case "d": return -1 !== i.toLowerCase().indexOf("d"); case "h": case "H": return -1 !== i.toLowerCase().indexOf("h"); case "m": return -1 !== i.indexOf("m"); case "s": return -1 !== i.indexOf("s"); default: return !1 } }, z = function () { return y("h") || y("m") || y("s") }, A = function () { return y("y") || y("M") || y("d") }, B = function () { var b = a("<thead>").append(a("<tr>").append(a("<th>").addClass("prev").attr("data-action", "previous").append(a("<span>").addClass(d.icons.previous))).append(a("<th>").addClass("picker-switch").attr("data-action", "pickerSwitch").attr("colspan", d.calendarWeeks ? "6" : "5")).append(a("<th>").addClass("next").attr("data-action", "next").append(a("<span>").addClass(d.icons.next)))), c = a("<tbody>").append(a("<tr>").append(a("<td>").attr("colspan", d.calendarWeeks ? "8" : "7"))); return [a("<div>").addClass("datepicker-days").append(a("<table>").addClass("table-condensed").append(b).append(a("<tbody>"))), a("<div>").addClass("datepicker-months").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())), a("<div>").addClass("datepicker-years").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())), a("<div>").addClass("datepicker-decades").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone()))] }, C = function () { var b = a("<tr>"), c = a("<tr>"), e = a("<tr>"); return y("h") && (b.append(a("<td>").append(a("<a>").attr({ href: "#", tabindex: "-1", title: d.tooltips.incrementHour }).addClass("btn").attr("data-action", "incrementHours").append(a("<span>").addClass(d.icons.up)))), c.append(a("<td>").append(a("<span>").addClass("timepicker-hour").attr({ "data-time-component": "hours", title: d.tooltips.pickHour }).attr("data-action", "showHours"))), e.append(a("<td>").append(a("<a>").attr({ href: "#", tabindex: "-1", title: d.tooltips.decrementHour }).addClass("btn").attr("data-action", "decrementHours").append(a("<span>").addClass(d.icons.down))))), y("m") && (y("h") && (b.append(a("<td>").addClass("separator")), c.append(a("<td>").addClass("separator").html(":")), e.append(a("<td>").addClass("separator"))), b.append(a("<td>").append(a("<a>").attr({ href: "#", tabindex: "-1", title: d.tooltips.incrementMinute }).addClass("btn").attr("data-action", "incrementMinutes").append(a("<span>").addClass(d.icons.up)))), c.append(a("<td>").append(a("<span>").addClass("timepicker-minute").attr({ "data-time-component": "minutes", title: d.tooltips.pickMinute }).attr("data-action", "showMinutes"))), e.append(a("<td>").append(a("<a>").attr({ href: "#", tabindex: "-1", title: d.tooltips.decrementMinute }).addClass("btn").attr("data-action", "decrementMinutes").append(a("<span>").addClass(d.icons.down))))), y("s") && (y("m") && (b.append(a("<td>").addClass("separator")), c.append(a("<td>").addClass("separator").html(":")), e.append(a("<td>").addClass("separator"))), b.append(a("<td>").append(a("<a>").attr({ href: "#", tabindex: "-1", title: d.tooltips.incrementSecond }).addClass("btn").attr("data-action", "incrementSeconds").append(a("<span>").addClass(d.icons.up)))), c.append(a("<td>").append(a("<span>").addClass("timepicker-second").attr({ "data-time-component": "seconds", title: d.tooltips.pickSecond }).attr("data-action", "showSeconds"))), e.append(a("<td>").append(a("<a>").attr({ href: "#", tabindex: "-1", title: d.tooltips.decrementSecond }).addClass("btn").attr("data-action", "decrementSeconds").append(a("<span>").addClass(d.icons.down))))), h || (b.append(a("<td>").addClass("separator")), c.append(a("<td>").append(a("<button>").addClass("btn btn-primary").attr({ "data-action": "togglePeriod", tabindex: "-1", title: d.tooltips.togglePeriod }))), e.append(a("<td>").addClass("separator"))), a("<div>").addClass("timepicker-picker").append(a("<table>").addClass("table-condensed").append([b, c, e])) }, D = function () { var b = a("<div>").addClass("timepicker-hours").append(a("<table>").addClass("table-condensed")), c = a("<div>").addClass("timepicker-minutes").append(a("<table>").addClass("table-condensed")), d = a("<div>").addClass("timepicker-seconds").append(a("<table>").addClass("table-condensed")), e = [C()]; return y("h") && e.push(b), y("m") && e.push(c), y("s") && e.push(d), e }, E = function () { var b = []; return d.showTodayButton && b.push(a("<td>").append(a("<a>").attr({ "data-action": "today", title: d.tooltips.today }).append(a("<span>").addClass(d.icons.today)))), !d.sideBySide && A() && z() && b.push(a("<td>").append(a("<a>").attr({ "data-action": "togglePicker", title: d.tooltips.selectTime }).append(a("<span>").addClass(d.icons.time)))), d.showClear && b.push(a("<td>").append(a("<a>").attr({ "data-action": "clear", title: d.tooltips.clear }).append(a("<span>").addClass(d.icons.clear)))), d.showClose && b.push(a("<td>").append(a("<a>").attr({ "data-action": "close", title: d.tooltips.close }).append(a("<span>").addClass(d.icons.close)))), a("<table>").addClass("table-condensed").append(a("<tbody>").append(a("<tr>").append(b))) }, F = function () { var b = a("<div>").addClass("bootstrap-datetimepicker-widget dropdown-menu"), c = a("<div>").addClass("datepicker").append(B()), e = a("<div>").addClass("timepicker").append(D()), f = a("<ul>").addClass("list-unstyled"), g = a("<li>").addClass("picker-switch" + (d.collapse ? " accordion-toggle" : "")).append(E()); return d.inline && b.removeClass("dropdown-menu"), h && b.addClass("usetwentyfour"), y("s") && !h && b.addClass("wider"), d.sideBySide && A() && z() ? (b.addClass("timepicker-sbs"), "top" === d.toolbarPlacement && b.append(g), b.append(a("<div>").addClass("row").append(c.addClass("col-md-6")).append(e.addClass("col-md-6"))), "bottom" === d.toolbarPlacement && b.append(g), b) : ("top" === d.toolbarPlacement && f.append(g), A() && f.append(a("<li>").addClass(d.collapse && z() ? "collapse in" : "").append(c)), "default" === d.toolbarPlacement && f.append(g), z() && f.append(a("<li>").addClass(d.collapse && A() ? "collapse" : "").append(e)), "bottom" === d.toolbarPlacement && f.append(g), b.append(f)) }, G = function () { var b, e = {}; return b = c.is("input") || d.inline ? c.data() : c.find("input").data(), b.dateOptions && b.dateOptions instanceof Object && (e = a.extend(!0, e, b.dateOptions)), a.each(d, function (a) { var c = "date" + a.charAt(0).toUpperCase() + a.slice(1); void 0 !== b[c] && (e[a] = b[c]) }), e }, H = function () { var b, e = (n || c).position(), f = (n || c).offset(), g = d.widgetPositioning.vertical, h = d.widgetPositioning.horizontal; if (d.widgetParent) b = d.widgetParent.append(o); else if (c.is("input")) b = c.after(o).parent(); else { if (d.inline) return void (b = c.append(o)); b = c, c.children().first().after(o) } if ("auto" === g && (g = f.top + 1.5 * o.height() >= a(window).height() + a(window).scrollTop() && o.height() + c.outerHeight() < f.top ? "top" : "bottom"), "auto" === h && (h = b.width() < f.left + o.outerWidth() / 2 && f.left + o.outerWidth() > a(window).width() ? "right" : "left"), "top" === g ? o.addClass("top").removeClass("bottom") : o.addClass("bottom").removeClass("top"), "right" === h ? o.addClass("pull-right") : o.removeClass("pull-right"), "relative" !== b.css("position") && (b = b.parents().filter(function () { return "relative" === a(this).css("position") }).first()), 0 === b.length) throw new Error("datetimepicker component should be placed within a relative positioned container"); o.css({ top: "top" === g ? "auto" : e.top + c.outerHeight(), bottom: "top" === g ? e.top + c.outerHeight() : "auto", left: "left" === h ? b === c ? 0 : e.left : "auto", right: "left" === h ? "auto" : b.outerWidth() - c.outerWidth() - (b === c ? 0 : e.left) }) }, I = function (a) { "dp.change" === a.type && (a.date && a.date.isSame(a.oldDate) || !a.date && !a.oldDate) || c.trigger(a) }, J = function (a) { "y" === a && (a = "YYYY"), I({ type: "dp.update", change: a, viewDate: f.clone() }) }, K = function (a) { o && (a && (k = Math.max(p, Math.min(3, k + a))), o.find(".datepicker > div").hide().filter(".datepicker-" + q[k].clsName).show()) }, L = function () { var b = a("<tr>"), c = f.clone().startOf("w").startOf("d"); for (d.calendarWeeks === !0 && b.append(a("<th>").addClass("cw").text("#")) ; c.isBefore(f.clone().endOf("w")) ;) b.append(a("<th>").addClass("dow").text(c.format("dd"))), c.add(1, "d"); o.find(".datepicker-days thead").append(b) }, M = function (a) { return d.disabledDates[a.format("YYYY-MM-DD")] === !0 }, N = function (a) { return d.enabledDates[a.format("YYYY-MM-DD")] === !0 }, O = function (a) { return d.disabledHours[a.format("H")] === !0 }, P = function (a) { return d.enabledHours[a.format("H")] === !0 }, Q = function (b, c) { if (!b.isValid()) return !1; if (d.disabledDates && "d" === c && M(b)) return !1; if (d.enabledDates && "d" === c && !N(b)) return !1; if (d.minDate && b.isBefore(d.minDate, c)) return !1; if (d.maxDate && b.isAfter(d.maxDate, c)) return !1; if (d.daysOfWeekDisabled && "d" === c && -1 !== d.daysOfWeekDisabled.indexOf(b.day())) return !1; if (d.disabledHours && ("h" === c || "m" === c || "s" === c) && O(b)) return !1; if (d.enabledHours && ("h" === c || "m" === c || "s" === c) && !P(b)) return !1; if (d.disabledTimeIntervals && ("h" === c || "m" === c || "s" === c)) { var e = !1; if (a.each(d.disabledTimeIntervals, function () { return b.isBetween(this[0], this[1]) ? (e = !0, !1) : void 0 }), e) return !1 } return !0 }, R = function () { for (var b = [], c = f.clone().startOf("y").startOf("d") ; c.isSame(f, "y") ;) b.push(a("<span>").attr("data-action", "selectMonth").addClass("month").text(c.format("MMM"))), c.add(1, "M"); o.find(".datepicker-months td").empty().append(b) }, S = function () { var b = o.find(".datepicker-months"), c = b.find("th"), g = b.find("tbody").find("span"); c.eq(0).find("span").attr("title", d.tooltips.prevYear), c.eq(1).attr("title", d.tooltips.selectYear), c.eq(2).find("span").attr("title", d.tooltips.nextYear), b.find(".disabled").removeClass("disabled"), Q(f.clone().subtract(1, "y"), "y") || c.eq(0).addClass("disabled"), c.eq(1).text(f.year()), Q(f.clone().add(1, "y"), "y") || c.eq(2).addClass("disabled"), g.removeClass("active"), e.isSame(f, "y") && !m && g.eq(e.month()).addClass("active"), g.each(function (b) { Q(f.clone().month(b), "M") || a(this).addClass("disabled") }) }, T = function () { var a = o.find(".datepicker-years"), b = a.find("th"), c = f.clone().subtract(5, "y"), g = f.clone().add(6, "y"), h = ""; for (b.eq(0).find("span").attr("title", d.tooltips.prevDecade), b.eq(1).attr("title", d.tooltips.selectDecade), b.eq(2).find("span").attr("title", d.tooltips.nextDecade), a.find(".disabled").removeClass("disabled"), d.minDate && d.minDate.isAfter(c, "y") && b.eq(0).addClass("disabled"), b.eq(1).text(c.year() + "-" + g.year()), d.maxDate && d.maxDate.isBefore(g, "y") && b.eq(2).addClass("disabled") ; !c.isAfter(g, "y") ;) h += '<span data-action="selectYear" class="year' + (c.isSame(e, "y") && !m ? " active" : "") + (Q(c, "y") ? "" : " disabled") + '">' + c.year() + "</span>", c.add(1, "y"); a.find("td").html(h) }, U = function () { var a = o.find(".datepicker-decades"), c = a.find("th"), g = b({ y: f.year() - f.year() % 100 - 1 }), h = g.clone().add(100, "y"), i = g.clone(), j = ""; for (c.eq(0).find("span").attr("title", d.tooltips.prevCentury), c.eq(2).find("span").attr("title", d.tooltips.nextCentury), a.find(".disabled").removeClass("disabled"), (g.isSame(b({ y: 1900 })) || d.minDate && d.minDate.isAfter(g, "y")) && c.eq(0).addClass("disabled"), c.eq(1).text(g.year() + "-" + h.year()), (g.isSame(b({ y: 2e3 })) || d.maxDate && d.maxDate.isBefore(h, "y")) && c.eq(2).addClass("disabled") ; !g.isAfter(h, "y") ;) j += '<span data-action="selectDecade" class="decade' + (g.isSame(e, "y") ? " active" : "") + (Q(g, "y") ? "" : " disabled") + '" data-selection="' + (g.year() + 6) + '">' + (g.year() + 1) + " - " + (g.year() + 12) + "</span>", g.add(12, "y"); j += "<span></span><span></span><span></span>", a.find("td").html(j), c.eq(1).text(i.year() + 1 + "-" + g.year()) }, V = function () { var b, c, g, h, i = o.find(".datepicker-days"), j = i.find("th"), k = []; if (A()) { for (j.eq(0).find("span").attr("title", d.tooltips.prevMonth), j.eq(1).attr("title", d.tooltips.selectMonth), j.eq(2).find("span").attr("title", d.tooltips.nextMonth), i.find(".disabled").removeClass("disabled"), j.eq(1).text(f.format(d.dayViewHeaderFormat)), Q(f.clone().subtract(1, "M"), "M") || j.eq(0).addClass("disabled"), Q(f.clone().add(1, "M"), "M") || j.eq(2).addClass("disabled"), b = f.clone().startOf("M").startOf("w").startOf("d"), h = 0; 42 > h; h++) 0 === b.weekday() && (c = a("<tr>"), d.calendarWeeks && c.append('<td class="cw">' + b.week() + "</td>"), k.push(c)), g = "", b.isBefore(f, "M") && (g += " old"), b.isAfter(f, "M") && (g += " new"), b.isSame(e, "d") && !m && (g += " active"), Q(b, "d") || (g += " disabled"), b.isSame(x(), "d") && (g += " today"), (0 === b.day() || 6 === b.day()) && (g += " weekend"), c.append('<td data-action="selectDay" data-day="' + b.format("L") + '" class="day' + g + '">' + b.date() + "</td>"), b.add(1, "d"); i.find("tbody").empty().append(k), S(), T(), U() } }, W = function () { var b = o.find(".timepicker-hours table"), c = f.clone().startOf("d"), d = [], e = a("<tr>"); for (f.hour() > 11 && !h && c.hour(12) ; c.isSame(f, "d") && (h || f.hour() < 12 && c.hour() < 12 || f.hour() > 11) ;) c.hour() % 4 === 0 && (e = a("<tr>"), d.push(e)), e.append('<td data-action="selectHour" class="hour' + (Q(c, "h") ? "" : " disabled") + '">' + c.format(h ? "HH" : "hh") + "</td>"), c.add(1, "h"); b.empty().append(d) }, X = function () { for (var b = o.find(".timepicker-minutes table"), c = f.clone().startOf("h"), e = [], g = a("<tr>"), h = 1 === d.stepping ? 5 : d.stepping; f.isSame(c, "h") ;) c.minute() % (4 * h) === 0 && (g = a("<tr>"), e.push(g)), g.append('<td data-action="selectMinute" class="minute' + (Q(c, "m") ? "" : " disabled") + '">' + c.format("mm") + "</td>"), c.add(h, "m"); b.empty().append(e) }, Y = function () { for (var b = o.find(".timepicker-seconds table"), c = f.clone().startOf("m"), d = [], e = a("<tr>") ; f.isSame(c, "m") ;) c.second() % 20 === 0 && (e = a("<tr>"), d.push(e)), e.append('<td data-action="selectSecond" class="second' + (Q(c, "s") ? "" : " disabled") + '">' + c.format("ss") + "</td>"), c.add(5, "s"); b.empty().append(d) }, Z = function () { var a, b, c = o.find(".timepicker span[data-time-component]"); h || (a = o.find(".timepicker [data-action=togglePeriod]"), b = e.clone().add(e.hours() >= 12 ? -12 : 12, "h"), a.text(e.format("A")), Q(b, "h") ? a.removeClass("disabled") : a.addClass("disabled")), c.filter("[data-time-component=hours]").text(e.format(h ? "HH" : "hh")), c.filter("[data-time-component=minutes]").text(e.format("mm")), c.filter("[data-time-component=seconds]").text(e.format("ss")), W(), X(), Y() }, $ = function () { o && (V(), Z()) }, _ = function (a) { var b = m ? null : e; return a ? (a = a.clone().locale(d.locale), 1 !== d.stepping && a.minutes(Math.round(a.minutes() / d.stepping) * d.stepping % 60).seconds(0), void (Q(a) ? (e = a, f = e.clone(), g.val(e.format(i)), c.data("date", e.format(i)), m = !1, $(), I({ type: "dp.change", date: e.clone(), oldDate: b })) : (d.keepInvalid || g.val(m ? "" : e.format(i)), I({ type: "dp.error", date: a })))) : (m = !0, g.val(""), c.data("date", ""), I({ type: "dp.change", date: !1, oldDate: b }), void $()) }, aa = function () { var b = !1; return o ? (o.find(".collapse").each(function () { var c = a(this).data("collapse"); return c && c.transitioning ? (b = !0, !1) : !0 }), b ? l : (n && n.hasClass("btn") && n.toggleClass("active"), o.hide(), a(window).off("resize", H), o.off("click", "[data-action]"), o.off("mousedown", !1), o.remove(), o = !1, I({ type: "dp.hide", date: e.clone() }), g.blur(), l)) : l }, ba = function () { _(null) }, ca = { next: function () { var a = q[k].navFnc; f.add(q[k].navStep, a), V(), J(a) }, previous: function () { var a = q[k].navFnc; f.subtract(q[k].navStep, a), V(), J(a) }, pickerSwitch: function () { K(1) }, selectMonth: function (b) { var c = a(b.target).closest("tbody").find("span").index(a(b.target)); f.month(c), k === p ? (_(e.clone().year(f.year()).month(f.month())), d.inline || aa()) : (K(-1), V()), J("M") }, selectYear: function (b) { var c = parseInt(a(b.target).text(), 10) || 0; f.year(c), k === p ? (_(e.clone().year(f.year())), d.inline || aa()) : (K(-1), V()), J("YYYY") }, selectDecade: function (b) { var c = parseInt(a(b.target).data("selection"), 10) || 0; f.year(c), k === p ? (_(e.clone().year(f.year())), d.inline || aa()) : (K(-1), V()), J("YYYY") }, selectDay: function (b) { var c = f.clone(); a(b.target).is(".old") && c.subtract(1, "M"), a(b.target).is(".new") && c.add(1, "M"), _(c.date(parseInt(a(b.target).text(), 10))), z() || d.keepOpen || d.inline || aa() }, incrementHours: function () { var a = e.clone().add(1, "h"); Q(a, "h") && _(a) }, incrementMinutes: function () { var a = e.clone().add(d.stepping, "m"); Q(a, "m") && _(a) }, incrementSeconds: function () { var a = e.clone().add(1, "s"); Q(a, "s") && _(a) }, decrementHours: function () { var a = e.clone().subtract(1, "h"); Q(a, "h") && _(a) }, decrementMinutes: function () { var a = e.clone().subtract(d.stepping, "m"); Q(a, "m") && _(a) }, decrementSeconds: function () { var a = e.clone().subtract(1, "s"); Q(a, "s") && _(a) }, togglePeriod: function () { _(e.clone().add(e.hours() >= 12 ? -12 : 12, "h")) }, togglePicker: function (b) { var c, e = a(b.target), f = e.closest("ul"), g = f.find(".in"), h = f.find(".collapse:not(.in)"); if (g && g.length) { if (c = g.data("collapse"), c && c.transitioning) return; g.collapse ? (g.collapse("hide"), h.collapse("show")) : (g.removeClass("in"), h.addClass("in")), e.is("span") ? e.toggleClass(d.icons.time + " " + d.icons.date) : e.find("span").toggleClass(d.icons.time + " " + d.icons.date) } }, showPicker: function () { o.find(".timepicker > div:not(.timepicker-picker)").hide(), o.find(".timepicker .timepicker-picker").show() }, showHours: function () { o.find(".timepicker .timepicker-picker").hide(), o.find(".timepicker .timepicker-hours").show() }, showMinutes: function () { o.find(".timepicker .timepicker-picker").hide(), o.find(".timepicker .timepicker-minutes").show() }, showSeconds: function () { o.find(".timepicker .timepicker-picker").hide(), o.find(".timepicker .timepicker-seconds").show() }, selectHour: function (b) { var c = parseInt(a(b.target).text(), 10); h || (e.hours() >= 12 ? 12 !== c && (c += 12) : 12 === c && (c = 0)), _(e.clone().hours(c)), ca.showPicker.call(l) }, selectMinute: function (b) { _(e.clone().minutes(parseInt(a(b.target).text(), 10))), ca.showPicker.call(l) }, selectSecond: function (b) { _(e.clone().seconds(parseInt(a(b.target).text(), 10))), ca.showPicker.call(l) }, clear: ba, today: function () { var a = x(); Q(a, "d") && _(a) }, close: aa }, da = function (b) { return a(b.currentTarget).is(".disabled") ? !1 : (ca[a(b.currentTarget).data("action")].apply(l, arguments), !1) }, ea = function () { var b, c = { year: function (a) { return a.month(0).date(1).hours(0).seconds(0).minutes(0) }, month: function (a) { return a.date(1).hours(0).seconds(0).minutes(0) }, day: function (a) { return a.hours(0).seconds(0).minutes(0) }, hour: function (a) { return a.seconds(0).minutes(0) }, minute: function (a) { return a.seconds(0) } }; return g.prop("disabled") || !d.ignoreReadonly && g.prop("readonly") || o ? l : (void 0 !== g.val() && 0 !== g.val().trim().length ? _(ga(g.val().trim())) : d.useCurrent && m && (g.is("input") && 0 === g.val().trim().length || d.inline) && (b = x(), "string" == typeof d.useCurrent && (b = c[d.useCurrent](b)), _(b)), o = F(), L(), R(), o.find(".timepicker-hours").hide(), o.find(".timepicker-minutes").hide(), o.find(".timepicker-seconds").hide(), $(), K(), a(window).on("resize", H), o.on("click", "[data-action]", da), o.on("mousedown", !1), n && n.hasClass("btn") && n.toggleClass("active"), o.show(), H(), d.focusOnShow && !g.is(":focus") && g.focus(), I({ type: "dp.show" }), l) }, fa = function () { return o ? aa() : ea() }, ga = function (a) { return a = void 0 === d.parseInputDate ? b.isMoment(a) || a instanceof Date ? b(a) : x(a) : d.parseInputDate(a), a.locale(d.locale), a }, ha = function (a) { var b, c, e, f, g = null, h = [], i = {}, j = a.which, k = "p"; w[j] = k; for (b in w) w.hasOwnProperty(b) && w[b] === k && (h.push(b), parseInt(b, 10) !== j && (i[b] = !0)); for (b in d.keyBinds) if (d.keyBinds.hasOwnProperty(b) && "function" == typeof d.keyBinds[b] && (e = b.split(" "), e.length === h.length && v[j] === e[e.length - 1])) { for (f = !0, c = e.length - 2; c >= 0; c--) if (!(v[e[c]] in i)) { f = !1; break } if (f) { g = d.keyBinds[b]; break } } g && (g.call(l, o), a.stopPropagation(), a.preventDefault()) }, ia = function (a) { w[a.which] = "r", a.stopPropagation(), a.preventDefault() }, ja = function (b) { var c = a(b.target).val().trim(), d = c ? ga(c) : null; return _(d), b.stopImmediatePropagation(), !1 }, ka = function () { g.on({ change: ja, blur: d.debug ? "" : aa, keydown: ha, keyup: ia, focus: d.allowInputToggle ? ea : "" }), c.is("input") ? g.on({ focus: ea }) : n && (n.on("click", fa), n.on("mousedown", !1)) }, la = function () { g.off({ change: ja, blur: blur, keydown: ha, keyup: ia, focus: d.allowInputToggle ? aa : "" }), c.is("input") ? g.off({ focus: ea }) : n && (n.off("click", fa), n.off("mousedown", !1)) }, ma = function (b) { var c = {}; return a.each(b, function () { var a = ga(this); a.isValid() && (c[a.format("YYYY-MM-DD")] = !0) }), Object.keys(c).length ? c : !1 }, na = function (b) { var c = {}; return a.each(b, function () { c[this] = !0 }), Object.keys(c).length ? c : !1 }, oa = function () { var a = d.format || "L LT"; i = a.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (a) { var b = e.localeData().longDateFormat(a) || a; return b.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (a) { return e.localeData().longDateFormat(a) || a }) }), j = d.extraFormats ? d.extraFormats.slice() : [], j.indexOf(a) < 0 && j.indexOf(i) < 0 && j.push(i), h = i.toLowerCase().indexOf("a") < 1 && i.replace(/\[.*?\]/g, "").indexOf("h") < 1, y("y") && (p = 2), y("M") && (p = 1), y("d") && (p = 0), k = Math.max(p, k), m || _(e) }; if (l.destroy = function () { aa(), la(), c.removeData("DateTimePicker"), c.removeData("date") }, l.toggle = fa, l.show = ea, l.hide = aa, l.disable = function () { return aa(), n && n.hasClass("btn") && n.addClass("disabled"), g.prop("disabled", !0), l }, l.enable = function () { return n && n.hasClass("btn") && n.removeClass("disabled"), g.prop("disabled", !1), l }, l.ignoreReadonly = function (a) { if (0 === arguments.length) return d.ignoreReadonly; if ("boolean" != typeof a) throw new TypeError("ignoreReadonly () expects a boolean parameter"); return d.ignoreReadonly = a, l }, l.options = function (b) { if (0 === arguments.length) return a.extend(!0, {}, d); if (!(b instanceof Object)) throw new TypeError("options() options parameter should be an object"); return a.extend(!0, d, b), a.each(d, function (a, b) { if (void 0 === l[a]) throw new TypeError("option " + a + " is not recognized!"); l[a](b) }), l }, l.date = function (a) { if (0 === arguments.length) return m ? null : e.clone(); if (!(null === a || "string" == typeof a || b.isMoment(a) || a instanceof Date)) throw new TypeError("date() parameter must be one of [null, string, moment or Date]"); return _(null === a ? null : ga(a)), l }, l.format = function (a) { if (0 === arguments.length) return d.format; if ("string" != typeof a && ("boolean" != typeof a || a !== !1)) throw new TypeError("format() expects a sting or boolean:false parameter " + a); return d.format = a, i && oa(), l }, l.timeZone = function (a) { return 0 === arguments.length ? d.timeZone : (d.timeZone = a, l) }, l.dayViewHeaderFormat = function (a) { if (0 === arguments.length) return d.dayViewHeaderFormat; if ("string" != typeof a) throw new TypeError("dayViewHeaderFormat() expects a string parameter"); return d.dayViewHeaderFormat = a, l }, l.extraFormats = function (a) { if (0 === arguments.length) return d.extraFormats; if (a !== !1 && !(a instanceof Array)) throw new TypeError("extraFormats() expects an array or false parameter"); return d.extraFormats = a, j && oa(), l }, l.disabledDates = function (b) { if (0 === arguments.length) return d.disabledDates ? a.extend({}, d.disabledDates) : d.disabledDates; if (!b) return d.disabledDates = !1, $(), l; if (!(b instanceof Array)) throw new TypeError("disabledDates() expects an array parameter"); return d.disabledDates = ma(b), d.enabledDates = !1, $(), l }, l.enabledDates = function (b) { if (0 === arguments.length) return d.enabledDates ? a.extend({}, d.enabledDates) : d.enabledDates; if (!b) return d.enabledDates = !1, $(), l; if (!(b instanceof Array)) throw new TypeError("enabledDates() expects an array parameter"); return d.enabledDates = ma(b), d.disabledDates = !1, $(), l }, l.daysOfWeekDisabled = function (a) { if (0 === arguments.length) return d.daysOfWeekDisabled.splice(0); if ("boolean" == typeof a && !a) return d.daysOfWeekDisabled = !1, $(), l; if (!(a instanceof Array)) throw new TypeError("daysOfWeekDisabled() expects an array parameter"); if (d.daysOfWeekDisabled = a.reduce(function (a, b) { return b = parseInt(b, 10), b > 6 || 0 > b || isNaN(b) ? a : (-1 === a.indexOf(b) && a.push(b), a) }, []).sort(), d.useCurrent && !d.keepInvalid) { for (var b = 0; !Q(e, "d") ;) { if (e.add(1, "d"), 7 === b) throw "Tried 7 times to find a valid date"; b++ } _(e) } return $(), l }, l.maxDate = function (a) { if (0 === arguments.length) return d.maxDate ? d.maxDate.clone() : d.maxDate; if ("boolean" == typeof a && a === !1) return d.maxDate = !1, $(), l; "string" == typeof a && ("now" === a || "moment" === a) && (a = x()); var b = ga(a); if (!b.isValid()) throw new TypeError("maxDate() Could not parse date parameter: " + a); if (d.minDate && b.isBefore(d.minDate)) throw new TypeError("maxDate() date parameter is before options.minDate: " + b.format(i)); return d.maxDate = b, d.useCurrent && !d.keepInvalid && e.isAfter(a) && _(d.maxDate), f.isAfter(b) && (f = b.clone().subtract(d.stepping, "m")), $(), l }, l.minDate = function (a) { if (0 === arguments.length) return d.minDate ? d.minDate.clone() : d.minDate; if ("boolean" == typeof a && a === !1) return d.minDate = !1, $(), l; "string" == typeof a && ("now" === a || "moment" === a) && (a = x()); var b = ga(a); if (!b.isValid()) throw new TypeError("minDate() Could not parse date parameter: " + a); if (d.maxDate && b.isAfter(d.maxDate)) throw new TypeError("minDate() date parameter is after options.maxDate: " + b.format(i)); return d.minDate = b, d.useCurrent && !d.keepInvalid && e.isBefore(a) && _(d.minDate), f.isBefore(b) && (f = b.clone().add(d.stepping, "m")), $(), l }, l.defaultDate = function (a) { if (0 === arguments.length) return d.defaultDate ? d.defaultDate.clone() : d.defaultDate; if (!a) return d.defaultDate = !1, l; "string" == typeof a && ("now" === a || "moment" === a) && (a = x()); var b = ga(a); if (!b.isValid()) throw new TypeError("defaultDate() Could not parse date parameter: " + a); if (!Q(b)) throw new TypeError("defaultDate() date passed is invalid according to component setup validations"); return d.defaultDate = b, (d.defaultDate && d.inline || "" === g.val().trim()) && _(d.defaultDate), l }, l.locale = function (a) { if (0 === arguments.length) return d.locale; if (!b.localeData(a)) throw new TypeError("locale() locale " + a + " is not loaded from moment locales!"); return d.locale = a, e.locale(d.locale), f.locale(d.locale), i && oa(), o && (aa(), ea()), l }, l.stepping = function (a) { return 0 === arguments.length ? d.stepping : (a = parseInt(a, 10), (isNaN(a) || 1 > a) && (a = 1), d.stepping = a, l) }, l.useCurrent = function (a) { var b = ["year", "month", "day", "hour", "minute"]; if (0 === arguments.length) return d.useCurrent; if ("boolean" != typeof a && "string" != typeof a) throw new TypeError("useCurrent() expects a boolean or string parameter"); if ("string" == typeof a && -1 === b.indexOf(a.toLowerCase())) throw new TypeError("useCurrent() expects a string parameter of " + b.join(", ")); return d.useCurrent = a, l }, l.collapse = function (a) { if (0 === arguments.length) return d.collapse; if ("boolean" != typeof a) throw new TypeError("collapse() expects a boolean parameter"); return d.collapse === a ? l : (d.collapse = a, o && (aa(), ea()), l) }, l.icons = function (b) { if (0 === arguments.length) return a.extend({}, d.icons); if (!(b instanceof Object)) throw new TypeError("icons() expects parameter to be an Object"); return a.extend(d.icons, b), o && (aa(), ea()), l }, l.tooltips = function (b) { if (0 === arguments.length) return a.extend({}, d.tooltips); if (!(b instanceof Object)) throw new TypeError("tooltips() expects parameter to be an Object"); return a.extend(d.tooltips, b), o && (aa(), ea()), l }, l.useStrict = function (a) { if (0 === arguments.length) return d.useStrict; if ("boolean" != typeof a) throw new TypeError("useStrict() expects a boolean parameter"); return d.useStrict = a, l }, l.sideBySide = function (a) { if (0 === arguments.length) return d.sideBySide; if ("boolean" != typeof a) throw new TypeError("sideBySide() expects a boolean parameter"); return d.sideBySide = a, o && (aa(), ea()), l }, l.viewMode = function (a) { if (0 === arguments.length) return d.viewMode; if ("string" != typeof a) throw new TypeError("viewMode() expects a string parameter"); if (-1 === r.indexOf(a)) throw new TypeError("viewMode() parameter must be one of (" + r.join(", ") + ") value"); return d.viewMode = a, k = Math.max(r.indexOf(a), p), K(), l }, l.toolbarPlacement = function (a) { if (0 === arguments.length) return d.toolbarPlacement; if ("string" != typeof a) throw new TypeError("toolbarPlacement() expects a string parameter"); if (-1 === u.indexOf(a)) throw new TypeError("toolbarPlacement() parameter must be one of (" + u.join(", ") + ") value"); return d.toolbarPlacement = a, o && (aa(), ea()), l }, l.widgetPositioning = function (b) { if (0 === arguments.length) return a.extend({}, d.widgetPositioning); if ("[object Object]" !== {}.toString.call(b)) throw new TypeError("widgetPositioning() expects an object variable"); if (b.horizontal) { if ("string" != typeof b.horizontal) throw new TypeError("widgetPositioning() horizontal variable must be a string"); if (b.horizontal = b.horizontal.toLowerCase(), -1 === t.indexOf(b.horizontal)) throw new TypeError("widgetPositioning() expects horizontal parameter to be one of (" + t.join(", ") + ")"); d.widgetPositioning.horizontal = b.horizontal } if (b.vertical) { if ("string" != typeof b.vertical) throw new TypeError("widgetPositioning() vertical variable must be a string"); if (b.vertical = b.vertical.toLowerCase(), -1 === s.indexOf(b.vertical)) throw new TypeError("widgetPositioning() expects vertical parameter to be one of (" + s.join(", ") + ")"); d.widgetPositioning.vertical = b.vertical } return $(), l }, l.calendarWeeks = function (a) { if (0 === arguments.length) return d.calendarWeeks; if ("boolean" != typeof a) throw new TypeError("calendarWeeks() expects parameter to be a boolean value"); return d.calendarWeeks = a, $(), l }, l.showTodayButton = function (a) { if (0 === arguments.length) return d.showTodayButton; if ("boolean" != typeof a) throw new TypeError("showTodayButton() expects a boolean parameter"); return d.showTodayButton = a, o && (aa(), ea()), l }, l.showClear = function (a) { if (0 === arguments.length) return d.showClear; if ("boolean" != typeof a) throw new TypeError("showClear() expects a boolean parameter"); return d.showClear = a, o && (aa(), ea()), l }, l.widgetParent = function (b) { if (0 === arguments.length) return d.widgetParent; if ("string" == typeof b && (b = a(b)), null !== b && "string" != typeof b && !(b instanceof a)) throw new TypeError("widgetParent() expects a string or a jQuery object parameter"); return d.widgetParent = b, o && (aa(), ea()), l }, l.keepOpen = function (a) { if (0 === arguments.length) return d.keepOpen; if ("boolean" != typeof a) throw new TypeError("keepOpen() expects a boolean parameter"); return d.keepOpen = a, l }, l.focusOnShow = function (a) { if (0 === arguments.length) return d.focusOnShow; if ("boolean" != typeof a) throw new TypeError("focusOnShow() expects a boolean parameter"); return d.focusOnShow = a, l }, l.inline = function (a) { if (0 === arguments.length) return d.inline; if ("boolean" != typeof a) throw new TypeError("inline() expects a boolean parameter"); return d.inline = a, l }, l.clear = function () { return ba(), l }, l.keyBinds = function (a) { return d.keyBinds = a, l }, l.getMoment = function (a) { return x(a) }, l.debug = function (a) { if ("boolean" != typeof a) throw new TypeError("debug() expects a boolean parameter"); return d.debug = a, l }, l.allowInputToggle = function (a) { if (0 === arguments.length) return d.allowInputToggle; if ("boolean" != typeof a) throw new TypeError("allowInputToggle() expects a boolean parameter"); return d.allowInputToggle = a, l }, l.showClose = function (a) { if (0 === arguments.length) return d.showClose; if ("boolean" != typeof a) throw new TypeError("showClose() expects a boolean parameter"); return d.showClose = a, l }, l.keepInvalid = function (a) { if (0 === arguments.length) return d.keepInvalid; if ("boolean" != typeof a) throw new TypeError("keepInvalid() expects a boolean parameter"); return d.keepInvalid = a, l }, l.datepickerInput = function (a) { if (0 === arguments.length) return d.datepickerInput; if ("string" != typeof a) throw new TypeError("datepickerInput() expects a string parameter"); return d.datepickerInput = a, l }, l.parseInputDate = function (a) {
		if (0 === arguments.length) return d.parseInputDate;
		if ("function" != typeof a) throw new TypeError("parseInputDate() sholud be as function"); return d.parseInputDate = a, l
		}, l.disabledTimeIntervals = function (b) { if (0 === arguments.length) return d.disabledTimeIntervals ? a.extend({}, d.disabledTimeIntervals) : d.disabledTimeIntervals; if (!b) return d.disabledTimeIntervals = !1, $(), l; if (!(b instanceof Array)) throw new TypeError("disabledTimeIntervals() expects an array parameter"); return d.disabledTimeIntervals = b, $(), l }, l.disabledHours = function (b) { if (0 === arguments.length) return d.disabledHours ? a.extend({}, d.disabledHours) : d.disabledHours; if (!b) return d.disabledHours = !1, $(), l; if (!(b instanceof Array)) throw new TypeError("disabledHours() expects an array parameter"); if (d.disabledHours = na(b), d.enabledHours = !1, d.useCurrent && !d.keepInvalid) { for (var c = 0; !Q(e, "h") ;) { if (e.add(1, "h"), 24 === c) throw "Tried 24 times to find a valid date"; c++ } _(e) } return $(), l }, l.enabledHours = function (b) { if (0 === arguments.length) return d.enabledHours ? a.extend({}, d.enabledHours) : d.enabledHours; if (!b) return d.enabledHours = !1, $(), l; if (!(b instanceof Array)) throw new TypeError("enabledHours() expects an array parameter"); if (d.enabledHours = na(b), d.disabledHours = !1, d.useCurrent && !d.keepInvalid) { for (var c = 0; !Q(e, "h") ;) { if (e.add(1, "h"), 24 === c) throw "Tried 24 times to find a valid date"; c++ } _(e) } return $(), l }, l.viewDate = function (a) { if (0 === arguments.length) return f.clone(); if (!a) return f = e.clone(), l; if (!("string" == typeof a || b.isMoment(a) || a instanceof Date)) throw new TypeError("viewDate() parameter must be one of [string, moment or Date]"); return f = ga(a), J(), l }, c.is("input")) g = c; else if (g = c.find(d.datepickerInput), 0 === g.length) g = c.find("input"); else if (!g.is("input")) throw new Error('CSS class "' + d.datepickerInput + '" cannot be applied to non input element'); if (c.hasClass("input-group") && (n = 0 === c.find(".datepickerbutton").length ? c.find(".input-group-addon") : c.find(".datepickerbutton")), !d.inline && !g.is("input")) throw new Error("Could not initialize DateTimePicker without an input element"); return e = x(), f = e.clone(), a.extend(!0, d, G()), l.options(d), oa(), ka(), g.prop("disabled") && l.disable(), g.is("input") && 0 !== g.val().trim().length ? _(ga(g.val().trim())) : d.defaultDate && void 0 === g.attr("placeholder") && _(d.defaultDate), d.inline && ea(), l
	}; a.fn.datetimepicker = function (b) { return this.each(function () { var d = a(this); d.data("DateTimePicker") || (b = a.extend(!0, {}, a.fn.datetimepicker.defaults, b), d.data("DateTimePicker", c(d, b))) }) }, a.fn.datetimepicker.defaults = { timeZone: "Etc/UTC", format: !1, dayViewHeaderFormat: "MMMM YYYY", extraFormats: !1, stepping: 1, minDate: !1, maxDate: !1, useCurrent: !0, collapse: !0, locale: b.locale(), defaultDate: !1, disabledDates: !1, enabledDates: !1, icons: { time: "glyphicon glyphicon-time", date: "glyphicon glyphicon-calendar", up: "glyphicon glyphicon-chevron-up", down: "glyphicon glyphicon-chevron-down", previous: "glyphicon glyphicon-chevron-left", next: "glyphicon glyphicon-chevron-right", today: "glyphicon glyphicon-screenshot", clear: "glyphicon glyphicon-trash", close: "glyphicon glyphicon-remove" }, tooltips: { today: "Go to today", clear: "Clear selection", close: "Close the picker", selectMonth: "Select Month", prevMonth: "Previous Month", nextMonth: "Next Month", selectYear: "Select Year", prevYear: "Previous Year", nextYear: "Next Year", selectDecade: "Select Decade", prevDecade: "Previous Decade", nextDecade: "Next Decade", prevCentury: "Previous Century", nextCentury: "Next Century", pickHour: "Pick Hour", incrementHour: "Increment Hour", decrementHour: "Decrement Hour", pickMinute: "Pick Minute", incrementMinute: "Increment Minute", decrementMinute: "Decrement Minute", pickSecond: "Pick Second", incrementSecond: "Increment Second", decrementSecond: "Decrement Second", togglePeriod: "Toggle Period", selectTime: "Select Time" }, useStrict: !1, sideBySide: !1, daysOfWeekDisabled: !1, calendarWeeks: !1, viewMode: "days", toolbarPlacement: "default", showTodayButton: !1, showClear: !1, showClose: !1, widgetPositioning: { horizontal: "auto", vertical: "auto" }, widgetParent: null, ignoreReadonly: !1, keepOpen: !1, focusOnShow: !0, inline: !1, keepInvalid: !1, datepickerInput: ".datepickerinput", keyBinds: { up: function (a) { if (a) { var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") ? this.date(b.clone().subtract(7, "d")) : this.date(b.clone().add(this.stepping(), "m")) } }, down: function (a) { if (!a) return void this.show(); var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") ? this.date(b.clone().add(7, "d")) : this.date(b.clone().subtract(this.stepping(), "m")) }, "control up": function (a) { if (a) { var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") ? this.date(b.clone().subtract(1, "y")) : this.date(b.clone().add(1, "h")) } }, "control down": function (a) { if (a) { var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") ? this.date(b.clone().add(1, "y")) : this.date(b.clone().subtract(1, "h")) } }, left: function (a) { if (a) { var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") && this.date(b.clone().subtract(1, "d")) } }, right: function (a) { if (a) { var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") && this.date(b.clone().add(1, "d")) } }, pageUp: function (a) { if (a) { var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") && this.date(b.clone().subtract(1, "M")) } }, pageDown: function (a) { if (a) { var b = this.date() || this.getMoment(); a.find(".datepicker").is(":visible") && this.date(b.clone().add(1, "M")) } }, enter: function () { this.hide() }, escape: function () { this.hide() }, "control space": function (a) { a.find(".timepicker").is(":visible") && a.find('.btn[data-action="togglePeriod"]').click() }, t: function () { this.date(this.getMoment()) }, "delete": function () { this.clear() } }, debug: !1, allowInputToggle: !1, disabledTimeIntervals: !1, disabledHours: !1, enabledHours: !1, viewDate: !1 }
});

*/

// try

/*! version : 4.17.37
 =========================================================
 bootstrap-datetimejs
 https://github.com/Eonasdan/bootstrap-datetimepicker
 Copyright (c) 2015 Jonathan Peterson
 =========================================================
 */
/*
 The MIT License (MIT)
 Copyright (c) 2015 Jonathan Peterson
 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.
 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */
/*global define:false */
/*global exports:false */
/*global require:false */
/*global jQuery:false */
/*global moment:false */
(function (factory) {
	'use strict';
	if (typeof define === 'function' && define.amd) {
		// AMD is used - Register as an anonymous module.
		define(['jquery', 'moment'], factory);
	} else if (typeof exports === 'object') {
		factory(require('jquery'), require('moment'));
	} else {
		// Neither AMD nor CommonJS used. Use global variables.
		if (typeof jQuery === 'undefined') {
			throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
		}
		if (typeof moment === 'undefined') {
			throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
		}
		factory(jQuery, moment);
	}
}(function ($, moment) {
	'use strict';
	if (!moment) {
		throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
	}

	var dateTimePicker = function (element, options) {
		var picker = {},
            date,
            viewDate,
            unset = true,
            input,
            component = false,
            widget = false,
            use24Hours,
            minViewModeNumber = 0,
            actualFormat,
            parseFormats,
            currentViewMode,
            datePickerModes = [
                {
                	clsName: 'days',
                	navFnc: 'M',
                	navStep: 1
                },
                {
                	clsName: 'months',
                	navFnc: 'y',
                	navStep: 1
                },
                {
                	clsName: 'years',
                	navFnc: 'y',
                	navStep: 10
                },
                {
                	clsName: 'decades',
                	navFnc: 'y',
                	navStep: 100
                }
            ],
            viewModes = ['days', 'months', 'years', 'decades'],
            verticalModes = ['top', 'bottom', 'auto'],
            horizontalModes = ['left', 'right', 'auto'],
            toolbarPlacements = ['default', 'top', 'bottom'],
            keyMap = {
            	'up': 38,
            	38: 'up',
            	'down': 40,
            	40: 'down',
            	'left': 37,
            	37: 'left',
            	'right': 39,
            	39: 'right',
            	'tab': 9,
            	9: 'tab',
            	'escape': 27,
            	27: 'escape',
            	'enter': 13,
            	13: 'enter',
            	'pageUp': 33,
            	33: 'pageUp',
            	'pageDown': 34,
            	34: 'pageDown',
            	'shift': 16,
            	16: 'shift',
            	'control': 17,
            	17: 'control',
            	'space': 32,
            	32: 'space',
            	't': 84,
            	84: 't',
            	'delete': 46,
            	46: 'delete'
            },
            keyState = {},

            /********************************************************************************
             *
             * Private functions
             *
             ********************************************************************************/
            getMoment = function (d) {
            	var tzEnabled = false,
                    returnMoment,
                    currentZoneOffset,
                    incomingZoneOffset,
                    timeZoneIndicator,
                    dateWithTimeZoneInfo;

            	if (moment.tz !== undefined && options.timeZone !== undefined && options.timeZone !== null && options.timeZone !== '') {
            		tzEnabled = true;
            	}
            	if (d === undefined || d === null) {
            		if (tzEnabled) {
            			returnMoment = moment().tz(options.timeZone).startOf('d');
            		} else {
            			returnMoment = moment().startOf('d');
            		}
            	} else {
            		if (tzEnabled) {
            			currentZoneOffset = moment().tz(options.timeZone).utcOffset();
            			incomingZoneOffset = moment(d, parseFormats, options.useStrict).utcOffset();
            			if (incomingZoneOffset !== currentZoneOffset) {
            				timeZoneIndicator = moment().tz(options.timeZone).format('Z');
            				dateWithTimeZoneInfo = moment(d, parseFormats, options.useStrict).format('YYYY-MM-DD[T]HH:mm:ss') + timeZoneIndicator;
            				returnMoment = moment(dateWithTimeZoneInfo, parseFormats, options.useStrict).tz(options.timeZone);
            			} else {
            				returnMoment = moment(d, parseFormats, options.useStrict).tz(options.timeZone);
            			}
            		} else {
            			returnMoment = moment(d, parseFormats, options.useStrict);
            		}
            	}
            	return returnMoment;
            },
            isEnabled = function (granularity) {
            	if (typeof granularity !== 'string' || granularity.length > 1) {
            		throw new TypeError('isEnabled expects a single character string parameter');
            	}
            	switch (granularity) {
            		case 'y':
            			return actualFormat.indexOf('Y') !== -1;
            		case 'M':
            			return actualFormat.indexOf('M') !== -1;
            		case 'd':
            			return actualFormat.toLowerCase().indexOf('d') !== -1;
            		case 'h':
            		case 'H':
            			return actualFormat.toLowerCase().indexOf('h') !== -1;
            		case 'm':
            			return actualFormat.indexOf('m') !== -1;
            		case 's':
            			return actualFormat.indexOf('s') !== -1;
            		default:
            			return false;
            	}
            },
            hasTime = function () {
            	return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
            },

            hasDate = function () {
            	return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
            },

            getDatePickerTemplate = function () {
            	var headTemplate = $('<thead>')
                        .append($('<tr>')
                            .append($('<th>').addClass('prev').attr('data-action', 'previous')
                                .append($('<span>').addClass(options.icons.previous))
                                )
                            .append($('<th>').addClass('picker-switch').attr('data-action', 'pickerSwitch').attr('colspan', (options.calendarWeeks ? '6' : '5')))
                            .append($('<th>').addClass('next').attr('data-action', 'next')
                                .append($('<span>').addClass(options.icons.next))
                                )
                            ),
                    contTemplate = $('<tbody>')
                        .append($('<tr>')
                            .append($('<td>').attr('colspan', (options.calendarWeeks ? '8' : '7')))
                            );

            	return [
                    $('<div>').addClass('datepicker-days')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate)
                            .append($('<tbody>'))
                            ),
                    $('<div>').addClass('datepicker-months')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-years')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-decades')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            )
            	];
            },

            getTimePickerMainTemplate = function () {
            	var topRow = $('<tr>'),
                    middleRow = $('<tr>'),
                    bottomRow = $('<tr>');

            	if (isEnabled('h')) {
            		topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour }).addClass('btn').attr('data-action', 'incrementHours')
                            .append($('<span>').addClass(options.icons.up))));
            		middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-hour').attr({ 'data-time-component': 'hours', 'title': options.tooltips.pickHour }).attr('data-action', 'showHours')));
            		bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour }).addClass('btn').attr('data-action', 'decrementHours')
                            .append($('<span>').addClass(options.icons.down))));
            	}
            	if (isEnabled('m')) {
            		if (isEnabled('h')) {
            			topRow.append($('<td>').addClass('separator'));
            			middleRow.append($('<td>').addClass('separator').html(':'));
            			bottomRow.append($('<td>').addClass('separator'));
            		}
            		topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute }).addClass('btn').attr('data-action', 'incrementMinutes')
                            .append($('<span>').addClass(options.icons.up))));
            		middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-minute').attr({ 'data-time-component': 'minutes', 'title': options.tooltips.pickMinute }).attr('data-action', 'showMinutes')));
            		bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute }).addClass('btn').attr('data-action', 'decrementMinutes')
                            .append($('<span>').addClass(options.icons.down))));
            	}
            	if (isEnabled('s')) {
            		if (isEnabled('m')) {
            			topRow.append($('<td>').addClass('separator'));
            			middleRow.append($('<td>').addClass('separator').html(':'));
            			bottomRow.append($('<td>').addClass('separator'));
            		}
            		topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond }).addClass('btn').attr('data-action', 'incrementSeconds')
                            .append($('<span>').addClass(options.icons.up))));
            		middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-second').attr({ 'data-time-component': 'seconds', 'title': options.tooltips.pickSecond }).attr('data-action', 'showSeconds')));
            		bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond }).addClass('btn').attr('data-action', 'decrementSeconds')
                            .append($('<span>').addClass(options.icons.down))));
            	}

            	if (!use24Hours) {
            		topRow.append($('<td>').addClass('separator'));
            		middleRow.append($('<td>')
                        .append($('<button>').addClass('btn btn-primary').attr({ 'data-action': 'togglePeriod', tabindex: '-1', 'title': options.tooltips.togglePeriod })));
            		bottomRow.append($('<td>').addClass('separator'));
            	}

            	return $('<div>').addClass('timepicker-picker')
                    .append($('<table>').addClass('table-condensed')
                        .append([topRow, middleRow, bottomRow]));
            },

            getTimePickerTemplate = function () {
            	var hoursView = $('<div>').addClass('timepicker-hours')
                        .append($('<table>').addClass('table-condensed')),
                    minutesView = $('<div>').addClass('timepicker-minutes')
                        .append($('<table>').addClass('table-condensed')),
                    secondsView = $('<div>').addClass('timepicker-seconds')
                        .append($('<table>').addClass('table-condensed')),
                    ret = [getTimePickerMainTemplate()];

            	if (isEnabled('h')) {
            		ret.push(hoursView);
            	}
            	if (isEnabled('m')) {
            		ret.push(minutesView);
            	}
            	if (isEnabled('s')) {
            		ret.push(secondsView);
            	}

            	return ret;
            },

            getToolbar = function () {
            	var row = [];
            	if (options.showTodayButton) {
            		row.push($('<td>').append($('<a>').attr({ 'data-action': 'today', 'title': options.tooltips.today }).append($('<span>').addClass(options.icons.today))));
            	}
            	if (!options.sideBySide && hasDate() && hasTime()) {
            		row.push($('<td>').append($('<a>').attr({ 'data-action': 'togglePicker', 'title': options.tooltips.selectTime }).append($('<span>').addClass(options.icons.time))));
            	}
            	if (options.showClear) {
            		row.push($('<td>').append($('<a>').attr({ 'data-action': 'clear', 'title': options.tooltips.clear }).append($('<span>').addClass(options.icons.clear))));
            	}
            	if (options.showClose) {
            		row.push($('<td>').append($('<a>').attr({ 'data-action': 'close', 'title': options.tooltips.close }).append($('<span>').addClass(options.icons.close))));
            	}
            	return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
            },

            getTemplate = function () {
            	var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
                    dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
                    timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
                    content = $('<ul>').addClass('list-unstyled'),
                    toolbar = $('<li>').addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : '')).append(getToolbar());

            	if (options.inline) {
            		template.removeClass('dropdown-menu');
            	}

            	if (use24Hours) {
            		template.addClass('usetwentyfour');
            	}
            	if (isEnabled('s') && !use24Hours) {
            		template.addClass('wider');
            	}

            	if (options.sideBySide && hasDate() && hasTime()) {
            		template.addClass('timepicker-sbs');
            		if (options.toolbarPlacement === 'top') {
            			template.append(toolbar);
            		}
            		template.append(
                        $('<div>').addClass('row')
                            .append(dateView.addClass('col-md-6'))
                            .append(timeView.addClass('col-md-6'))
                    );
            		if (options.toolbarPlacement === 'bottom') {
            			template.append(toolbar);
            		}
            		return template;
            	}

            	if (options.toolbarPlacement === 'top') {
            		content.append(toolbar);
            	}
            	if (hasDate()) {
            		content.append($('<li>').addClass((options.collapse && hasTime() ? 'collapse in' : '')).append(dateView));
            	}
            	if (options.toolbarPlacement === 'default') {
            		content.append(toolbar);
            	}
            	if (hasTime()) {
            		content.append($('<li>').addClass((options.collapse && hasDate() ? 'collapse' : '')).append(timeView));
            	}
            	if (options.toolbarPlacement === 'bottom') {
            		content.append(toolbar);
				}
            	return template.append(content);
            },

            dataToOptions = function () {
            	var eData,
                    dataOptions = {};

            	if (element.is('input') || options.inline) {
            		eData = element.data();
            	} else {
            		eData = element.find('input').data();
            	}

            	if (eData.dateOptions && eData.dateOptions instanceof Object) {
            		dataOptions = $.extend(true, dataOptions, eData.dateOptions);
            	}

            	$.each(options, function (key) {
            		var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
            		if (eData[attributeName] !== undefined) {
            			dataOptions[key] = eData[attributeName];
            		}
            	});
            	return dataOptions;
            },

            place = function () {
            	var position = (component || element).position(),
                    offset = (component || element).offset(),
                    vertical = options.widgetPositioning.vertical,
                    horizontal = options.widgetPositioning.horizontal,
                    parent;

            	if (options.widgetParent) {
            		parent = options.widgetParent.append(widget);
            	} else if (element.is('input')) {
            		parent = element.after(widget).parent();
            	} else if (options.inline) {
            		parent = element.append(widget);
            		return;
            	} else {
            		parent = element;
            		element.children().first().after(widget);
            	}

            	// Top and bottom logic
            	if (vertical === 'auto') {
            		if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() &&
                        widget.height() + element.outerHeight() < offset.top) {
            			vertical = 'top';
            		} else {
            			vertical = 'bottom';
            		}
            	}

            	// Left and right logic
            	if (horizontal === 'auto') {
            		if (parent.width() < offset.left + widget.outerWidth() / 2 &&
                        offset.left + widget.outerWidth() > $(window).width()) {
            			horizontal = 'right';
            		} else {
            			horizontal = 'left';
            		}
            	}

            	if (vertical === 'top') {
            		widget.addClass('top').removeClass('bottom');
            	} else {
            		widget.addClass('bottom').removeClass('top');
            	}

            	if (horizontal === 'right') {
            		widget.addClass('pull-right');
            	} else {
            		widget.removeClass('pull-right');
            	}

            	// find the first parent element that has a relative css positioning
            	if (parent.css('position') !== 'relative') {
            		parent = parent.parents().filter(function () {
            			return $(this).css('position') === 'relative';
            		}).first();
            	}

            	if (parent.length === 0) {
            		throw new Error('datetimepicker component should be placed within a relative positioned container');
            	}

            	widget.css({
            		top: vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
            		bottom: vertical === 'top' ? position.top + element.outerHeight() : 'auto',
            		left: horizontal === 'left' ? (parent === element ? 0 : position.left) : 'auto',
            		right: horizontal === 'left' ? 'auto' : parent.outerWidth() - element.outerWidth() - (parent === element ? 0 : position.left)
            	});
            },

            notifyEvent = function (e) {
            	if (e.type === 'dp.change' && ((e.date && e.date.isSame(e.oldDate)) || (!e.date && !e.oldDate))) {
            		return;
            	}
            	element.trigger(e);
            },

            viewUpdate = function (e) {
            	if (e === 'y') {
            		e = 'YYYY';
            	}
            	notifyEvent({
            		type: 'dp.update',
            		change: e,
            		viewDate: viewDate.clone()
            	});
            },

            showMode = function (dir) {
            	if (!widget) {
            		return;
            	}
            	if (dir) {
            		currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
            	}
            	widget.find('.datepicker > div').hide().filter('.datepicker-' + datePickerModes[currentViewMode].clsName).css('display', 'block');
            },

            fillDow = function () {
            	var row = $('<tr>'),
                    currentDate = viewDate.clone().startOf('w').startOf('d');

            	if (options.calendarWeeks === true) {
            		row.append($('<th>').addClass('cw').text('#'));
            	}

            	while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
            		row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
            		currentDate.add(1, 'd');
            	}
            	widget.find('.datepicker-days thead').append(row);
            },

            isInDisabledDates = function (testDate) {
            	return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInEnabledDates = function (testDate) {
            	return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInDisabledHours = function (testDate) {
            	return options.disabledHours[testDate.format('H')] === true;
            },

            isInEnabledHours = function (testDate) {
            	return options.enabledHours[testDate.format('H')] === true;
            },

            isValid = function (targetMoment, granularity) {
            	if (!targetMoment.isValid()) {
            		return false;
            	}
            	if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
            		return false;
            	}
            	if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
            		return false;
            	}
            	if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
            		return false;
            	}
            	if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
            		return false;
            	}
            	if (options.daysOfWeekDisabled && granularity === 'd' && options.daysOfWeekDisabled.indexOf(targetMoment.day()) !== -1) {
            		return false;
            	}
            	if (options.disabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && isInDisabledHours(targetMoment)) {
            		return false;
            	}
            	if (options.enabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && !isInEnabledHours(targetMoment)) {
            		return false;
            	}
            	if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
            		var found = false;
            		$.each(options.disabledTimeIntervals, function () {
            			if (targetMoment.isBetween(this[0], this[1])) {
            				found = true;
            				return false;
            			}
            		});
            		if (found) {
            			return false;
            		}
            	}
            	return true;
            },

            fillMonths = function () {
            	var spans = [],
                    monthsShort = viewDate.clone().startOf('y').startOf('d');
            	while (monthsShort.isSame(viewDate, 'y')) {
            		spans.push($('<span>').attr('data-action', 'selectMonth').addClass('month').text(monthsShort.format('MMM')));
            		monthsShort.add(1, 'M');
				}
            	widget.find('.datepicker-months td').empty().append(spans);
            },

            updateMonths = function () {
            	var monthsView = widget.find('.datepicker-months'),
                    monthsViewHeader = monthsView.find('th'),
                    months = monthsView.find('tbody').find('span');

            	monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
            	monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
            	monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);

            	monthsView.find('.disabled').removeClass('disabled');

            	if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
            		monthsViewHeader.eq(0).addClass('disabled');
            	}

            	monthsViewHeader.eq(1).text(viewDate.year());

            	if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
            		monthsViewHeader.eq(2).addClass('disabled');
            	}

            	months.removeClass('active');
            	if (date.isSame(viewDate, 'y') && !unset) {
            		months.eq(date.month()).addClass('active');
            	}

            	months.each(function (index) {
            		if (!isValid(viewDate.clone().month(index), 'M')) {
            			$(this).addClass('disabled');
            		}
            	});
            },

            updateYears = function () {
            	var yearsView = widget.find('.datepicker-years'),
                    yearsViewHeader = yearsView.find('th'),
                    startYear = viewDate.clone().subtract(5, 'y'),
                    endYear = viewDate.clone().add(6, 'y'),
                    html = '';

            	yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
            	yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
            	yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);

            	yearsView.find('.disabled').removeClass('disabled');

            	if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
            		yearsViewHeader.eq(0).addClass('disabled');
            	}

            	yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());

            	if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
            		yearsViewHeader.eq(2).addClass('disabled');
            	}

            	while (!startYear.isAfter(endYear, 'y')) {
            		html += '<span data-action="selectYear" class="year' + (startYear.isSame(date, 'y') && !unset ? ' active' : '') + (!isValid(startYear, 'y') ? ' disabled' : '') + '">' + startYear.year() + '</span>';
            		startYear.add(1, 'y');
            	}

            	yearsView.find('td').html(html);
            },

            updateDecades = function () {
            	var decadesView = widget.find('.datepicker-decades'),
                    decadesViewHeader = decadesView.find('th'),
                    startDecade = moment({ y: viewDate.year() - (viewDate.year() % 100) - 1 }),
                    endDecade = startDecade.clone().add(100, 'y'),
                    startedAt = startDecade.clone(),
                    html = '';

            	decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
            	decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);

            	decadesView.find('.disabled').removeClass('disabled');

            	if (startDecade.isSame(moment({ y: 1900 })) || (options.minDate && options.minDate.isAfter(startDecade, 'y'))) {
            		decadesViewHeader.eq(0).addClass('disabled');
            	}

            	decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());

            	if (startDecade.isSame(moment({ y: 2000 })) || (options.maxDate && options.maxDate.isBefore(endDecade, 'y'))) {
            		decadesViewHeader.eq(2).addClass('disabled');
            	}

            	while (!startDecade.isAfter(endDecade, 'y')) {
            		html += '<span data-action="selectDecade" class="decade' + (startDecade.isSame(date, 'y') ? ' active' : '') +
                        (!isValid(startDecade, 'y') ? ' disabled' : '') + '" data-selection="' + (startDecade.year() + 6) + '">' + (startDecade.year() + 1) + ' - ' + (startDecade.year() + 12) + '</span>';
            		startDecade.add(12, 'y');
            	}
            	html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even

            	decadesView.find('td').html(html);
            	decadesViewHeader.eq(1).text((startedAt.year() + 1) + '-' + (startDecade.year()));
            },

            fillDate = function () {
            	var daysView = widget.find('.datepicker-days'),
                    daysViewHeader = daysView.find('th'),
                    currentDate,
                    html = [],
                    row,
                    clsName,
                    i;

            	if (!hasDate()) {
            		return;
            	}

            	daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
            	daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
            	daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);

            	daysView.find('.disabled').removeClass('disabled');
            	daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));

            	if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
            		daysViewHeader.eq(0).addClass('disabled');
            	}
            	if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
            		daysViewHeader.eq(2).addClass('disabled');
            	}

            	currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');

            	for (i = 0; i < 42; i++) { //always display 42 days (should show 6 weeks)
            		if (currentDate.weekday() === 0) {
            			row = $('<tr>');
            			if (options.calendarWeeks) {
            				row.append('<td class="cw">' + currentDate.week() + '</td>');
            			}
            			html.push(row);
            		}
            		clsName = '';
            		if (currentDate.isBefore(viewDate, 'M')) {
            			clsName += ' old';
            		}
            		if (currentDate.isAfter(viewDate, 'M')) {
            			clsName += ' new';
            		}
            		if (currentDate.isSame(date, 'd') && !unset) {
            			clsName += ' active';
            		}
            		if (!isValid(currentDate, 'd')) {
            			clsName += ' disabled';
            		}
            		if (currentDate.isSame(getMoment(), 'd')) {
            			clsName += ' today';
            		}
            		if (currentDate.day() === 0 || currentDate.day() === 6) {
            			clsName += ' weekend';
            		}
            		row.append('<td data-action="selectDay" data-day="' + currentDate.format('L') + '" class="day' + clsName + '">' + currentDate.date() + '</td>');
            		currentDate.add(1, 'd');
				}

            	daysView.find('tbody').empty().append(html);

            	updateMonths();

            	updateYears();

            	updateDecades();
            },

            fillHours = function () {
            	var table = widget.find('.timepicker-hours table'),
                    currentHour = viewDate.clone().startOf('d'),
                    html = [],
                    row = $('<tr>');

            	if (viewDate.hour() > 11 && !use24Hours) {
            		currentHour.hour(12);
            	}
            	while (currentHour.isSame(viewDate, 'd') && (use24Hours || (viewDate.hour() < 12 && currentHour.hour() < 12) || viewDate.hour() > 11)) {
            		if (currentHour.hour() % 4 === 0) {
            			row = $('<tr>');
            			html.push(row);
            		}
            		row.append('<td data-action="selectHour" class="hour' + (!isValid(currentHour, 'h') ? ' disabled' : '') + '">' + currentHour.format(use24Hours ? 'HH' : 'hh') + '</td>');
            		currentHour.add(1, 'h');
            	}
            	table.empty().append(html);
            },

            fillMinutes = function () {
            	var table = widget.find('.timepicker-minutes table'),
                    currentMinute = viewDate.clone().startOf('h'),
                    html = [],
                    row = $('<tr>'),
                    step = options.stepping === 1 ? 5 : options.stepping;

            	while (viewDate.isSame(currentMinute, 'h')) {
            		if (currentMinute.minute() % (step * 4) === 0) {
            			row = $('<tr>');
            			html.push(row);
            		}
            		row.append('<td data-action="selectMinute" class="minute' + (!isValid(currentMinute, 'm') ? ' disabled' : '') + '">' + currentMinute.format('mm') + '</td>');
            		currentMinute.add(step, 'm');
            	}
            	table.empty().append(html);
            },

            fillSeconds = function () {
            	var table = widget.find('.timepicker-seconds table'),
                    currentSecond = viewDate.clone().startOf('m'),
                    html = [],
                    row = $('<tr>');

            	while (viewDate.isSame(currentSecond, 'm')) {
            		if (currentSecond.second() % 20 === 0) {
            			row = $('<tr>');
            			html.push(row);
            		}
            		row.append('<td data-action="selectSecond" class="second' + (!isValid(currentSecond, 's') ? ' disabled' : '') + '">' + currentSecond.format('ss') + '</td>');
            		currentSecond.add(5, 's');
            	}

            	table.empty().append(html);
            },

            fillTime = function () {
            	var toggle, newDate, timeComponents = widget.find('.timepicker span[data-time-component]');

            	if (!use24Hours) {
            		toggle = widget.find('.timepicker [data-action=togglePeriod]');
            		newDate = date.clone().add((date.hours() >= 12) ? -12 : 12, 'h');

            		toggle.text(date.format('A'));

            		if (isValid(newDate, 'h')) {
            			toggle.removeClass('disabled');
            		} else {
            			toggle.addClass('disabled');
            		}
            	}
            	timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
            	timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
            	timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));

            	fillHours();
            	fillMinutes();
            	fillSeconds();
            },

            update = function () {
            	if (!widget) {
            		return;
            	}
            	fillDate();
            	fillTime();
            },

            setValue = function (targetMoment) {
            	var oldDate = unset ? null : date;

            	// case of calling setValue(null or false)
            	if (!targetMoment) {
            		unset = true;
            		input.val('');
            		element.data('date', '');
            		notifyEvent({
            			type: 'dp.change',
            			date: false,
            			oldDate: oldDate
            		});
            		update();
            		return;
            	}

            	targetMoment = targetMoment.clone().locale(options.locale);

            	if (options.stepping !== 1) {
            		targetMoment.minutes((Math.round(targetMoment.minutes() / options.stepping) * options.stepping) % 60).seconds(0);
            	}

            	if (isValid(targetMoment)) {
            		date = targetMoment;
            		viewDate = date.clone();
            		input.val(date.format(actualFormat));
            		element.data('date', date.format(actualFormat));
            		unset = false;
            		update();
            		notifyEvent({
            			type: 'dp.change',
            			date: date.clone(),
            			oldDate: oldDate
            		});
            	} else {
            		if (!options.keepInvalid) {
            			input.val(unset ? '' : date.format(actualFormat));
            		}
            		notifyEvent({
            			type: 'dp.error',
            			date: targetMoment
            		});
            	}
            },

            hide = function () {
            	///<summary>Hides the widget. Possibly will emit dp.hide</summary>
            	var transitioning = false;
            	if (!widget) {
            		return picker;
            	}
            	// Ignore event if in the middle of a picker transition
            	widget.find('.collapse').each(function () {
            		var collapseData = $(this).data('collapse');
            		if (collapseData && collapseData.transitioning) {
            			transitioning = true;
            			return false;
            		}
            		return true;
            	});
            	if (transitioning) {
            		return picker;
            	}
            	if (component && component.hasClass('btn')) {
            		component.toggleClass('active');
            	}
            	widget.hide();

            	$(window).off('resize', place);
            	widget.off('click', '[data-action]');
            	widget.off('mousedown', false);

            	widget.remove();
            	widget = false;

            	notifyEvent({
            		type: 'dp.hide',
            		date: date.clone()
            	});

            	input.blur();

            	return picker;
            },

            clear = function () {
            	setValue(null);
            },

            /********************************************************************************
             *
             * Widget UI interaction functions
             *
             ********************************************************************************/
            actions = {
            	next: function () {
            		var navFnc = datePickerModes[currentViewMode].navFnc;
            		viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
            		fillDate();
            		viewUpdate(navFnc);
            	},

            	previous: function () {
            		var navFnc = datePickerModes[currentViewMode].navFnc;
            		viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
            		fillDate();
            		viewUpdate(navFnc);
            	},

            	pickerSwitch: function () {
            		showMode(1);
            	},

            	selectMonth: function (e) {
            		var month = $(e.target).closest('tbody').find('span').index($(e.target));
            		viewDate.month(month);
            		if (currentViewMode === minViewModeNumber) {
            			setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
            			if (!options.inline) {
            				hide();
            			}
            		} else {
            			showMode(-1);
            			fillDate();
            		}
            		viewUpdate('M');
            	},

            	selectYear: function (e) {
            		var year = parseInt($(e.target).text(), 10) || 0;
            		viewDate.year(year);
            		if (currentViewMode === minViewModeNumber) {
            			setValue(date.clone().year(viewDate.year()));
            			if (!options.inline) {
            				hide();
            			}
            		} else {
            			showMode(-1);
            			fillDate();
            		}
            		viewUpdate('YYYY');
            	},

            	selectDecade: function (e) {
            		var year = parseInt($(e.target).data('selection'), 10) || 0;
            		viewDate.year(year);
            		if (currentViewMode === minViewModeNumber) {
            			setValue(date.clone().year(viewDate.year()));
            			if (!options.inline) {
            				hide();
            			}
            		} else {
            			showMode(-1);
            			fillDate();
            		}
            		viewUpdate('YYYY');
            	},

            	selectDay: function (e) {
            		var day = viewDate.clone();
            		if ($(e.target).is('.old')) {
            			day.subtract(1, 'M');
            		}
            		if ($(e.target).is('.new')) {
            			day.add(1, 'M');
            		}
            		setValue(day.date(parseInt($(e.target).text(), 10)));
            		if (!hasTime() && !options.keepOpen && !options.inline) {
            			hide();
            		}
            	},

            	incrementHours: function () {
            		var newDate = date.clone().add(1, 'h');
            		if (isValid(newDate, 'h')) {
            			setValue(newDate);
            		}
            	},

            	incrementMinutes: function () {
            		var newDate = date.clone().add(options.stepping, 'm');
            		if (isValid(newDate, 'm')) {
            			setValue(newDate);
            		}
            	},

            	incrementSeconds: function () {
            		var newDate = date.clone().add(1, 's');
            		if (isValid(newDate, 's')) {
            			setValue(newDate);
            		}
            	},

            	decrementHours: function () {
            		var newDate = date.clone().subtract(1, 'h');
            		if (isValid(newDate, 'h')) {
            			setValue(newDate);
            		}
            	},

            	decrementMinutes: function () {
            		var newDate = date.clone().subtract(options.stepping, 'm');
            		if (isValid(newDate, 'm')) {
            			setValue(newDate);
            		}
            	},

            	decrementSeconds: function () {
            		var newDate = date.clone().subtract(1, 's');
            		if (isValid(newDate, 's')) {
            			setValue(newDate);
            		}
            	},

            	togglePeriod: function () {
            		setValue(date.clone().add((date.hours() >= 12) ? -12 : 12, 'h'));
            	},

            	togglePicker: function (e) {
            		var $this = $(e.target),
                        $parent = $this.closest('ul'),
                        expanded = $parent.find('.in'),
                        closed = $parent.find('.collapse:not(.in)'),
                        collapseData;

            		if (expanded && expanded.length) {
            			collapseData = expanded.data('collapse');
            			if (collapseData && collapseData.transitioning) {
            				return;
            			}
            			if (expanded.collapse) { // if collapse plugin is available through bootstrap.js then use it
            				expanded.collapse('hide');
            				closed.collapse('show');
            			} else { // otherwise just toggle in class on the two views
            				expanded.removeClass('in');
            				closed.addClass('in');
            			}
            			if ($this.is('span')) {
            				$this.toggleClass(options.icons.time + ' ' + options.icons.date);
            			} else {
            				$this.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
            			}

            			// NOTE: uncomment if toggled state will be restored in show()
            			//if (component) {
            			//    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
            			//}
            		}
            	},

            	showPicker: function () {
            		widget.find('.timepicker > div:not(.timepicker-picker)').hide();
            		widget.find('.timepicker .timepicker-picker').show();
            	},

            	showHours: function () {
            		widget.find('.timepicker .timepicker-picker').hide();
            		widget.find('.timepicker .timepicker-hours').show();
            	},

            	showMinutes: function () {
            		widget.find('.timepicker .timepicker-picker').hide();
            		widget.find('.timepicker .timepicker-minutes').show();
            	},

            	showSeconds: function () {
            		widget.find('.timepicker .timepicker-picker').hide();
            		widget.find('.timepicker .timepicker-seconds').show();
            	},

            	selectHour: function (e) {
            		var hour = parseInt($(e.target).text(), 10);

            		if (!use24Hours) {
            			if (date.hours() >= 12) {
            				if (hour !== 12) {
            					hour += 12;
            				}
            			} else {
            				if (hour === 12) {
            					hour = 0;
            				}
            			}
            		}
            		setValue(date.clone().hours(hour));
            		actions.showPicker.call(picker);
            	},

            	selectMinute: function (e) {
            		setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
            		actions.showPicker.call(picker);
            	},

            	selectSecond: function (e) {
            		setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
            		actions.showPicker.call(picker);
            	},

            	clear: clear,

            	today: function () {
            		var todaysDate = getMoment();
            		if (isValid(todaysDate, 'd')) {
            			setValue(todaysDate);
            		}
            	},

            	close: hide
            },

            doAction = function (e) {
            	if ($(e.currentTarget).is('.disabled')) {
            		return false;
            	}
            	actions[$(e.currentTarget).data('action')].apply(picker, arguments);
            	return false;
            },

            show = function () {
            	///<summary>Shows the widget. Possibly will emit dp.show and dp.change</summary>
            	var currentMoment,
                    useCurrentGranularity = {
                    	'year': function (m) {
                    		return m.month(0).date(1).hours(0).seconds(0).minutes(0);
                    	},
                    	'month': function (m) {
                    		return m.date(1).hours(0).seconds(0).minutes(0);
                    	},
                    	'day': function (m) {
                    		return m.hours(0).seconds(0).minutes(0);
                    	},
                    	'hour': function (m) {
                    		return m.seconds(0).minutes(0);
                    	},
                    	'minute': function (m) {
                    		return m.seconds(0);
                    	}
                    };

            	if (input.prop('disabled') || (!options.ignoreReadonly && input.prop('readonly')) || widget) {
            		return picker;
            	}
            	if (input.val() !== undefined && input.val().trim().length !== 0) {
            		setValue(parseInputDate(input.val().trim()));
            	} else if (options.useCurrent && unset && ((input.is('input') && input.val().trim().length === 0) || options.inline)) {
            		currentMoment = getMoment();
            		if (typeof options.useCurrent === 'string') {
            			currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
            		}
            		setValue(currentMoment);
            	}

            	widget = getTemplate();

            	fillDow();
            	fillMonths();

            	widget.find('.timepicker-hours').hide();
            	widget.find('.timepicker-minutes').hide();
            	widget.find('.timepicker-seconds').hide();

            	update();
            	showMode();

            	$(window).on('resize', place);
            	widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
            	widget.on('mousedown', false);

            	if (component && component.hasClass('btn')) {
            		component.toggleClass('active');
				}
				widget.show();
				widget.css('display', 'block');
            	place();

            	if (options.focusOnShow && !input.is(':focus')) {
            		input.focus();
            	}

            	notifyEvent({
            		type: 'dp.show'
            	});
            	return picker;
            },

            toggle = function () {
            	/// <summary>Shows or hides the widget</summary>
            	return (widget ? hide() : show());
            },

            parseInputDate = function (inputDate) {
            	if (options.parseInputDate === undefined) {
            		if (moment.isMoment(inputDate) || inputDate instanceof Date) {
            			inputDate = moment(inputDate);
            		} else {
            			inputDate = getMoment(inputDate);
            		}
            	} else {
            		inputDate = options.parseInputDate(inputDate);
            	}
            	inputDate.locale(options.locale);
            	return inputDate;
            },

            keydown = function (e) {
            	var handler = null,
                    index,
                    index2,
                    pressedKeys = [],
                    pressedModifiers = {},
                    currentKey = e.which,
                    keyBindKeys,
                    allModifiersPressed,
                    pressed = 'p';

            	keyState[currentKey] = pressed;

            	for (index in keyState) {
            		if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
            			pressedKeys.push(index);
            			if (parseInt(index, 10) !== currentKey) {
            				pressedModifiers[index] = true;
            			}
            		}
            	}

            	for (index in options.keyBinds) {
            		if (options.keyBinds.hasOwnProperty(index) && typeof (options.keyBinds[index]) === 'function') {
            			keyBindKeys = index.split(' ');
            			if (keyBindKeys.length === pressedKeys.length && keyMap[currentKey] === keyBindKeys[keyBindKeys.length - 1]) {
            				allModifiersPressed = true;
            				for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
            					if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
            						allModifiersPressed = false;
            						break;
            					}
            				}
            				if (allModifiersPressed) {
            					handler = options.keyBinds[index];
            					break;
            				}
            			}
            		}
            	}

            	if (handler) {
            		handler.call(picker, widget);
            		e.stopPropagation();
            		e.preventDefault();
            	}
            },

            keyup = function (e) {
            	keyState[e.which] = 'r';
            	e.stopPropagation();
            	e.preventDefault();
            },

            change = function (e) {
            	var val = $(e.target).val().trim(),
                    parsedDate = val ? parseInputDate(val) : null;
            	setValue(parsedDate);
            	e.stopImmediatePropagation();
            	return false;
            },

            attachDatePickerElementEvents = function () {
            	input.on({
            		'change': change,
            		'blur': options.debug ? '' : hide,
            		'keydown': keydown,
            		'keyup': keyup,
            		'focus': options.allowInputToggle ? show : ''
            	});

            	if (element.is('input')) {
            		input.on({
            			'focus': show
            		});
            	} else if (component) {
            		component.on('click', toggle);
            		component.on('mousedown', false);
            	}
            },

            detachDatePickerElementEvents = function () {
            	input.off({
            		'change': change,
            		'blur': blur,
            		'keydown': keydown,
            		'keyup': keyup,
            		'focus': options.allowInputToggle ? hide : ''
            	});

            	if (element.is('input')) {
            		input.off({
            			'focus': show
            		});
            	} else if (component) {
            		component.off('click', toggle);
            		component.off('mousedown', false);
            	}
            },

            indexGivenDates = function (givenDatesArray) {
            	// Store given enabledDates and disabledDates as keys.
            	// This way we can check their existence in O(1) time instead of looping through whole array.
            	// (for example: options.enabledDates['2014-02-27'] === true)
            	var givenDatesIndexed = {};
            	$.each(givenDatesArray, function () {
            		var dDate = parseInputDate(this);
            		if (dDate.isValid()) {
            			givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
            		}
            	});
            	return (Object.keys(givenDatesIndexed).length) ? givenDatesIndexed : false;
            },

            indexGivenHours = function (givenHoursArray) {
            	// Store given enabledHours and disabledHours as keys.
            	// This way we can check their existence in O(1) time instead of looping through whole array.
            	// (for example: options.enabledHours['2014-02-27'] === true)
            	var givenHoursIndexed = {};
            	$.each(givenHoursArray, function () {
            		givenHoursIndexed[this] = true;
            	});
            	return (Object.keys(givenHoursIndexed).length) ? givenHoursIndexed : false;
            },

            initFormatting = function () {
            	var format = options.format || 'L LT';

            	actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput) {
            		var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
            		return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput2) { //temp fix for #740
            			return date.localeData().longDateFormat(formatInput2) || formatInput2;
            		});
            	});


            	parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
            	if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
            		parseFormats.push(actualFormat);
            	}

            	use24Hours = (actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1);

            	if (isEnabled('y')) {
            		minViewModeNumber = 2;
            	}
            	if (isEnabled('M')) {
            		minViewModeNumber = 1;
            	}
            	if (isEnabled('d')) {
            		minViewModeNumber = 0;
            	}

            	currentViewMode = Math.max(minViewModeNumber, currentViewMode);

            	if (!unset) {
            		setValue(date);
            	}
            };

		/********************************************************************************
         *
         * Public API functions
         * =====================
         *
         * Important: Do not expose direct references to private objects or the options
         * object to the outer world. Always return a clone when returning values or make
         * a clone when setting a private variable.
         *
         ********************************************************************************/
		picker.destroy = function () {
			///<summary>Destroys the widget and removes all attached event listeners</summary>
			hide();
			detachDatePickerElementEvents();
			element.removeData('DateTimePicker');
			element.removeData('date');
		};

		picker.toggle = toggle;

		picker.show = show;

		picker.hide = hide;

		picker.disable = function () {
			///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
			///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
			hide();
			if (component && component.hasClass('btn')) {
				component.addClass('disabled');
			}
			input.prop('disabled', true);
			return picker;
		};

		picker.enable = function () {
			///<summary>Enables the input element, the component is attached to, by removing disabled attribute from it.</summary>
			if (component && component.hasClass('btn')) {
				component.removeClass('disabled');
			}
			input.prop('disabled', false);
			return picker;
		};

		picker.ignoreReadonly = function (ignoreReadonly) {
			if (arguments.length === 0) {
				return options.ignoreReadonly;
			}
			if (typeof ignoreReadonly !== 'boolean') {
				throw new TypeError('ignoreReadonly () expects a boolean parameter');
			}
			options.ignoreReadonly = ignoreReadonly;
			return picker;
		};

		picker.options = function (newOptions) {
			if (arguments.length === 0) {
				return $.extend(true, {}, options);
			}

			if (!(newOptions instanceof Object)) {
				throw new TypeError('options() options parameter should be an object');
			}
			$.extend(true, options, newOptions);
			$.each(options, function (key, value) {
				if (picker[key] !== undefined) {
					picker[key](value);
				} else {
					throw new TypeError('option ' + key + ' is not recognized!');
				}
			});
			return picker;
		};

		picker.date = function (newDate) {
			///<signature helpKeyword="$.fn.datetimepicker.date">
			///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
			///<returns type="Moment">date.clone()</returns>
			///</signature>
			///<signature>
			///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
			///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param>
			///</signature>
			if (arguments.length === 0) {
				if (unset) {
					return null;
				}
				return date.clone();
			}

			if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
				throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
			}

			setValue(newDate === null ? null : parseInputDate(newDate));
			return picker;
		};

		picker.format = function (newFormat) {
			///<summary>test su</summary>
			///<param name="newFormat">info about para</param>
			///<returns type="string|boolean">returns foo</returns>
			if (arguments.length === 0) {
				return options.format;
			}

			if ((typeof newFormat !== 'string') && ((typeof newFormat !== 'boolean') || (newFormat !== false))) {
				throw new TypeError('format() expects a sting or boolean:false parameter ' + newFormat);
			}

			options.format = newFormat;
			if (actualFormat) {
				initFormatting(); // reinit formatting
			}
			return picker;
		};

		picker.timeZone = function (newZone) {
			if (arguments.length === 0) {
				return options.timeZone;
			}

			options.timeZone = newZone;

			return picker;
		};

		picker.dayViewHeaderFormat = function (newFormat) {
			if (arguments.length === 0) {
				return options.dayViewHeaderFormat;
			}

			if (typeof newFormat !== 'string') {
				throw new TypeError('dayViewHeaderFormat() expects a string parameter');
			}

			options.dayViewHeaderFormat = newFormat;
			return picker;
		};

		picker.extraFormats = function (formats) {
			if (arguments.length === 0) {
				return options.extraFormats;
			}

			if (formats !== false && !(formats instanceof Array)) {
				throw new TypeError('extraFormats() expects an array or false parameter');
			}

			options.extraFormats = formats;
			if (parseFormats) {
				initFormatting(); // reinit formatting
			}
			return picker;
		};

		picker.disabledDates = function (dates) {
			///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
			///<summary>Returns an array with the currently set disabled dates on the component.</summary>
			///<returns type="array">options.disabledDates</returns>
			///</signature>
			///<signature>
			///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
			///options.enabledDates if such exist.</summary>
			///<param name="dates" locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
			///</signature>
			if (arguments.length === 0) {
				return (options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates);
			}

			if (!dates) {
				options.disabledDates = false;
				update();
				return picker;
			}
			if (!(dates instanceof Array)) {
				throw new TypeError('disabledDates() expects an array parameter');
			}
			options.disabledDates = indexGivenDates(dates);
			options.enabledDates = false;
			update();
			return picker;
		};

		picker.enabledDates = function (dates) {
			///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
			///<summary>Returns an array with the currently set enabled dates on the component.</summary>
			///<returns type="array">options.enabledDates</returns>
			///</signature>
			///<signature>
			///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledDates if such exist.</summary>
			///<param name="dates" locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
			///</signature>
			if (arguments.length === 0) {
				return (options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates);
			}

			if (!dates) {
				options.enabledDates = false;
				update();
				return picker;
			}
			if (!(dates instanceof Array)) {
				throw new TypeError('enabledDates() expects an array parameter');
			}
			options.enabledDates = indexGivenDates(dates);
			options.disabledDates = false;
			update();
			return picker;
		};

		picker.daysOfWeekDisabled = function (daysOfWeekDisabled) {
			if (arguments.length === 0) {
				return options.daysOfWeekDisabled.splice(0);
			}

			if ((typeof daysOfWeekDisabled === 'boolean') && !daysOfWeekDisabled) {
				options.daysOfWeekDisabled = false;
				update();
				return picker;
			}

			if (!(daysOfWeekDisabled instanceof Array)) {
				throw new TypeError('daysOfWeekDisabled() expects an array parameter');
			}
			options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function (previousValue, currentValue) {
				currentValue = parseInt(currentValue, 10);
				if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
					return previousValue;
				}
				if (previousValue.indexOf(currentValue) === -1) {
					previousValue.push(currentValue);
				}
				return previousValue;
			}, []).sort();
			if (options.useCurrent && !options.keepInvalid) {
				var tries = 0;
				while (!isValid(date, 'd')) {
					date.add(1, 'd');
					if (tries === 7) {
						throw 'Tried 7 times to find a valid date';
					}
					tries++;
				}
				setValue(date);
			}
			update();
			return picker;
		};

		picker.maxDate = function (maxDate) {
			if (arguments.length === 0) {
				return options.maxDate ? options.maxDate.clone() : options.maxDate;
			}

			if ((typeof maxDate === 'boolean') && maxDate === false) {
				options.maxDate = false;
				update();
				return picker;
			}

			if (typeof maxDate === 'string') {
				if (maxDate === 'now' || maxDate === 'moment') {
					maxDate = getMoment();
				}
			}

			var parsedDate = parseInputDate(maxDate);

			if (!parsedDate.isValid()) {
				throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
			}
			if (options.minDate && parsedDate.isBefore(options.minDate)) {
				throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
			}
			options.maxDate = parsedDate;
			if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
				setValue(options.maxDate);
			}
			if (viewDate.isAfter(parsedDate)) {
				viewDate = parsedDate.clone().subtract(options.stepping, 'm');
			}
			update();
			return picker;
		};

		picker.minDate = function (minDate) {
			if (arguments.length === 0) {
				return options.minDate ? options.minDate.clone() : options.minDate;
			}

			if ((typeof minDate === 'boolean') && minDate === false) {
				options.minDate = false;
				update();
				return picker;
			}

			if (typeof minDate === 'string') {
				if (minDate === 'now' || minDate === 'moment') {
					minDate = getMoment();
				}
			}

			var parsedDate = parseInputDate(minDate);

			if (!parsedDate.isValid()) {
				throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
			}
			if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
				throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
			}
			options.minDate = parsedDate;
			if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
				setValue(options.minDate);
			}
			if (viewDate.isBefore(parsedDate)) {
				viewDate = parsedDate.clone().add(options.stepping, 'm');
			}
			update();
			return picker;
		};

		picker.defaultDate = function (defaultDate) {
			///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
			///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
			///<returns type="Moment">date.clone()</returns>
			///</signature>
			///<signature>
			///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate parameter is cleared.</summary>
			///<param name="defaultDate" locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
			///</signature>
			if (arguments.length === 0) {
				return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
			}
			if (!defaultDate) {
				options.defaultDate = false;
				return picker;
			}

			if (typeof defaultDate === 'string') {
				if (defaultDate === 'now' || defaultDate === 'moment') {
					defaultDate = getMoment();
				}
			}

			var parsedDate = parseInputDate(defaultDate);
			if (!parsedDate.isValid()) {
				throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
			}
			if (!isValid(parsedDate)) {
				throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
			}

			options.defaultDate = parsedDate;

			if ((options.defaultDate && options.inline) || input.val().trim() === '') {
				setValue(options.defaultDate);
			}
			return picker;
		};

		picker.locale = function (locale) {
			if (arguments.length === 0) {
				return options.locale;
			}

			if (!moment.localeData(locale)) {
				throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
			}

			options.locale = locale;
			date.locale(options.locale);
			viewDate.locale(options.locale);

			if (actualFormat) {
				initFormatting(); // reinit formatting
			}
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.stepping = function (stepping) {
			if (arguments.length === 0) {
				return options.stepping;
			}

			stepping = parseInt(stepping, 10);
			if (isNaN(stepping) || stepping < 1) {
				stepping = 1;
			}
			options.stepping = stepping;
			return picker;
		};

		picker.useCurrent = function (useCurrent) {
			var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
			if (arguments.length === 0) {
				return options.useCurrent;
			}

			if ((typeof useCurrent !== 'boolean') && (typeof useCurrent !== 'string')) {
				throw new TypeError('useCurrent() expects a boolean or string parameter');
			}
			if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
				throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
			}
			options.useCurrent = useCurrent;
			return picker;
		};

		picker.collapse = function (collapse) {
			if (arguments.length === 0) {
				return options.collapse;
			}

			if (typeof collapse !== 'boolean') {
				throw new TypeError('collapse() expects a boolean parameter');
			}
			if (options.collapse === collapse) {
				return picker;
			}
			options.collapse = collapse;
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.icons = function (icons) {
			if (arguments.length === 0) {
				return $.extend({}, options.icons);
			}

			if (!(icons instanceof Object)) {
				throw new TypeError('icons() expects parameter to be an Object');
			}
			$.extend(options.icons, icons);
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.tooltips = function (tooltips) {
			if (arguments.length === 0) {
				return $.extend({}, options.tooltips);
			}

			if (!(tooltips instanceof Object)) {
				throw new TypeError('tooltips() expects parameter to be an Object');
			}
			$.extend(options.tooltips, tooltips);
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.useStrict = function (useStrict) {
			if (arguments.length === 0) {
				return options.useStrict;
			}

			if (typeof useStrict !== 'boolean') {
				throw new TypeError('useStrict() expects a boolean parameter');
			}
			options.useStrict = useStrict;
			return picker;
		};

		picker.sideBySide = function (sideBySide) {
			if (arguments.length === 0) {
				return options.sideBySide;
			}

			if (typeof sideBySide !== 'boolean') {
				throw new TypeError('sideBySide() expects a boolean parameter');
			}
			options.sideBySide = sideBySide;
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.viewMode = function (viewMode) {
			if (arguments.length === 0) {
				return options.viewMode;
			}

			if (typeof viewMode !== 'string') {
				throw new TypeError('viewMode() expects a string parameter');
			}

			if (viewModes.indexOf(viewMode) === -1) {
				throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
			}

			options.viewMode = viewMode;
			currentViewMode = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);

			showMode();
			return picker;
		};

		picker.toolbarPlacement = function (toolbarPlacement) {
			if (arguments.length === 0) {
				return options.toolbarPlacement;
			}

			if (typeof toolbarPlacement !== 'string') {
				throw new TypeError('toolbarPlacement() expects a string parameter');
			}
			if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
				throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
			}
			options.toolbarPlacement = toolbarPlacement;

			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.widgetPositioning = function (widgetPositioning) {
			if (arguments.length === 0) {
				return $.extend({}, options.widgetPositioning);
			}

			if (({}).toString.call(widgetPositioning) !== '[object Object]') {
				throw new TypeError('widgetPositioning() expects an object variable');
			}
			if (widgetPositioning.horizontal) {
				if (typeof widgetPositioning.horizontal !== 'string') {
					throw new TypeError('widgetPositioning() horizontal variable must be a string');
				}
				widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
				if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
					throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' + horizontalModes.join(', ') + ')');
				}
				options.widgetPositioning.horizontal = widgetPositioning.horizontal;
			}
			if (widgetPositioning.vertical) {
				if (typeof widgetPositioning.vertical !== 'string') {
					throw new TypeError('widgetPositioning() vertical variable must be a string');
				}
				widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
				if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
					throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' + verticalModes.join(', ') + ')');
				}
				options.widgetPositioning.vertical = widgetPositioning.vertical;
			}
			update();
			return picker;
		};

		picker.calendarWeeks = function (calendarWeeks) {
			if (arguments.length === 0) {
				return options.calendarWeeks;
			}

			if (typeof calendarWeeks !== 'boolean') {
				throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
			}

			options.calendarWeeks = calendarWeeks;
			update();
			return picker;
		};

		picker.showTodayButton = function (showTodayButton) {
			if (arguments.length === 0) {
				return options.showTodayButton;
			}

			if (typeof showTodayButton !== 'boolean') {
				throw new TypeError('showTodayButton() expects a boolean parameter');
			}

			options.showTodayButton = showTodayButton;
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.showClear = function (showClear) {
			if (arguments.length === 0) {
				return options.showClear;
			}

			if (typeof showClear !== 'boolean') {
				throw new TypeError('showClear() expects a boolean parameter');
			}

			options.showClear = showClear;
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.widgetParent = function (widgetParent) {
			if (arguments.length === 0) {
				return options.widgetParent;
			}

			if (typeof widgetParent === 'string') {
				widgetParent = $(widgetParent);
			}

			if (widgetParent !== null && (typeof widgetParent !== 'string' && !(widgetParent instanceof $))) {
				throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
			}

			options.widgetParent = widgetParent;
			if (widget) {
				hide();
				show();
			}
			return picker;
		};

		picker.keepOpen = function (keepOpen) {
			if (arguments.length === 0) {
				return options.keepOpen;
			}

			if (typeof keepOpen !== 'boolean') {
				throw new TypeError('keepOpen() expects a boolean parameter');
			}

			options.keepOpen = keepOpen;
			return picker;
		};

		picker.focusOnShow = function (focusOnShow) {
			if (arguments.length === 0) {
				return options.focusOnShow;
			}

			if (typeof focusOnShow !== 'boolean') {
				throw new TypeError('focusOnShow() expects a boolean parameter');
			}

			options.focusOnShow = focusOnShow;
			return picker;
		};

		picker.inline = function (inline) {
			if (arguments.length === 0) {
				return options.inline;
			}

			if (typeof inline !== 'boolean') {
				throw new TypeError('inline() expects a boolean parameter');
			}

			options.inline = inline;
			return picker;
		};

		picker.clear = function () {
			clear();
			return picker;
		};

		picker.keyBinds = function (keyBinds) {
			options.keyBinds = keyBinds;
			return picker;
		};

		picker.getMoment = function (d) {
			return getMoment(d);
		};

		picker.debug = function (debug) {
			if (typeof debug !== 'boolean') {
				throw new TypeError('debug() expects a boolean parameter');
			}

			options.debug = debug;
			return picker;
		};

		picker.allowInputToggle = function (allowInputToggle) {
			if (arguments.length === 0) {
				return options.allowInputToggle;
			}

			if (typeof allowInputToggle !== 'boolean') {
				throw new TypeError('allowInputToggle() expects a boolean parameter');
			}

			options.allowInputToggle = allowInputToggle;
			return picker;
		};

		picker.showClose = function (showClose) {
			if (arguments.length === 0) {
				return options.showClose;
			}

			if (typeof showClose !== 'boolean') {
				throw new TypeError('showClose() expects a boolean parameter');
			}

			options.showClose = showClose;
			return picker;
		};

		picker.keepInvalid = function (keepInvalid) {
			if (arguments.length === 0) {
				return options.keepInvalid;
			}

			if (typeof keepInvalid !== 'boolean') {
				throw new TypeError('keepInvalid() expects a boolean parameter');
			}
			options.keepInvalid = keepInvalid;
			return picker;
		};

		picker.datepickerInput = function (datepickerInput) {
			if (arguments.length === 0) {
				return options.datepickerInput;
			}

			if (typeof datepickerInput !== 'string') {
				throw new TypeError('datepickerInput() expects a string parameter');
			}

			options.datepickerInput = datepickerInput;
			return picker;
		};

		picker.parseInputDate = function (parseInputDate) {
			if (arguments.length === 0) {
				return options.parseInputDate;
			}

			if (typeof parseInputDate !== 'function') {
				throw new TypeError('parseInputDate() sholud be as function');
			}

			options.parseInputDate = parseInputDate;

			return picker;
		};

		picker.disabledTimeIntervals = function (disabledTimeIntervals) {
			///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
			///<summary>Returns an array with the currently set disabled dates on the component.</summary>
			///<returns type="array">options.disabledTimeIntervals</returns>
			///</signature>
			///<signature>
			///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
			///options.enabledDates if such exist.</summary>
			///<param name="dates" locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
			///</signature>
			if (arguments.length === 0) {
				return (options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals);
			}

			if (!disabledTimeIntervals) {
				options.disabledTimeIntervals = false;
				update();
				return picker;
			}
			if (!(disabledTimeIntervals instanceof Array)) {
				throw new TypeError('disabledTimeIntervals() expects an array parameter');
			}
			options.disabledTimeIntervals = disabledTimeIntervals;
			update();
			return picker;
		};

		picker.disabledHours = function (hours) {
			///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
			///<summary>Returns an array with the currently set disabled hours on the component.</summary>
			///<returns type="array">options.disabledHours</returns>
			///</signature>
			///<signature>
			///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
			///options.enabledHours if such exist.</summary>
			///<param name="hours" locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select only from those hours.</param>
			///</signature>
			if (arguments.length === 0) {
				return (options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours);
			}

			if (!hours) {
				options.disabledHours = false;
				update();
				return picker;
			}
			if (!(hours instanceof Array)) {
				throw new TypeError('disabledHours() expects an array parameter');
			}
			options.disabledHours = indexGivenHours(hours);
			options.enabledHours = false;
			if (options.useCurrent && !options.keepInvalid) {
				var tries = 0;
				while (!isValid(date, 'h')) {
					date.add(1, 'h');
					if (tries === 24) {
						throw 'Tried 24 times to find a valid date';
					}
					tries++;
				}
				setValue(date);
			}
			update();
			return picker;
		};

		picker.enabledHours = function (hours) {
			///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
			///<summary>Returns an array with the currently set enabled hours on the component.</summary>
			///<returns type="array">options.enabledHours</returns>
			///</signature>
			///<signature>
			///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledHours if such exist.</summary>
			///<param name="hours" locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only from those hours.</param>
			///</signature>
			if (arguments.length === 0) {
				return (options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours);
			}

			if (!hours) {
				options.enabledHours = false;
				update();
				return picker;
			}
			if (!(hours instanceof Array)) {
				throw new TypeError('enabledHours() expects an array parameter');
			}
			options.enabledHours = indexGivenHours(hours);
			options.disabledHours = false;
			if (options.useCurrent && !options.keepInvalid) {
				var tries = 0;
				while (!isValid(date, 'h')) {
					date.add(1, 'h');
					if (tries === 24) {
						throw 'Tried 24 times to find a valid date';
					}
					tries++;
				}
				setValue(date);
			}
			update();
			return picker;
		};

		picker.viewDate = function (newDate) {
			///<signature helpKeyword="$.fn.datetimepicker.viewDate">
			///<summary>Returns the component's model current viewDate, a moment object or null if not set.</summary>
			///<returns type="Moment">viewDate.clone()</returns>
			///</signature>
			///<signature>
			///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
			///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, viewDate, moment, null parameter.</param>
			///</signature>
			if (arguments.length === 0) {
				return viewDate.clone();
			}

			if (!newDate) {
				viewDate = date.clone();
				return picker;
			}

			if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
				throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
			}

			viewDate = parseInputDate(newDate);
			viewUpdate();
			return picker;
		};

		// initializing element and component attributes
		if (element.is('input')) {
			input = element;
		} else {
			input = element.find(options.datepickerInput);
			if (input.length === 0) {
				input = element.find('input');
			} else if (!input.is('input')) {
				throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
			}
		}

		if (element.hasClass('input-group')) {
			// in case there is more then one 'input-group-addon' Issue #48
			if (element.find('.datepickerbutton').length === 0) {
				component = element.find('.input-group-addon');
			} else {
				component = element.find('.datepickerbutton');
			}
		}

		if (!options.inline && !input.is('input')) {
			throw new Error('Could not initialize DateTimePicker without an input element');
		}

		// Set defaults for date here now instead of in var declaration
		date = getMoment();
		viewDate = date.clone();

		$.extend(true, options, dataToOptions());

		picker.options(options);

		initFormatting();

		attachDatePickerElementEvents();

		if (input.prop('disabled')) {
			picker.disable();
		}
		if (input.is('input') && input.val().trim().length !== 0) {
			setValue(parseInputDate(input.val().trim()));
		}
		else if (options.defaultDate && input.attr('placeholder') === undefined) {
			setValue(options.defaultDate);
		}
		if (options.inline) {
			show();
		}
		return picker;
	};

	/********************************************************************************
     *
     * jQuery plugin constructor and defaults object
     *
     ********************************************************************************/

	$.fn.datetimepicker = function (options) {
		return this.each(function () {
			var $this = $(this);
			if (!$this.data('DateTimePicker')) {
				// create a private copy of the defaults object
				options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
				$this.data('DateTimePicker', dateTimePicker($this, options));
			}
		});
	};

	$.fn.datetimepicker.defaults = {
		timeZone: 'Etc/UTC',
		format: false,
		dayViewHeaderFormat: 'MMMM YYYY',
		extraFormats: false,
		stepping: 1,
		minDate: false,
		maxDate: false,
		useCurrent: true,
		collapse: true,
		locale: moment.locale(),
		defaultDate: false,
		disabledDates: false,
		enabledDates: false,
		icons: {
			time: 'glyphicon glyphicon-time',
			date: 'glyphicon glyphicon-calendar',
			up: 'glyphicon glyphicon-chevron-up',
			down: 'glyphicon glyphicon-chevron-down',
			previous: 'glyphicon glyphicon-chevron-left',
			next: 'glyphicon glyphicon-chevron-right',
			today: 'glyphicon glyphicon-screenshot',
			clear: 'glyphicon glyphicon-trash',
			close: 'glyphicon glyphicon-remove'
		},
		tooltips: {
			today: 'Go to today',
			clear: 'Clear selection',
			close: 'Close the picker',
			selectMonth: 'Select Month',
			prevMonth: 'Previous Month',
			nextMonth: 'Next Month',
			selectYear: 'Select Year',
			prevYear: 'Previous Year',
			nextYear: 'Next Year',
			selectDecade: 'Select Decade',
			prevDecade: 'Previous Decade',
			nextDecade: 'Next Decade',
			prevCentury: 'Previous Century',
			nextCentury: 'Next Century',
			pickHour: 'Pick Hour',
			incrementHour: 'Increment Hour',
			decrementHour: 'Decrement Hour',
			pickMinute: 'Pick Minute',
			incrementMinute: 'Increment Minute',
			decrementMinute: 'Decrement Minute',
			pickSecond: 'Pick Second',
			incrementSecond: 'Increment Second',
			decrementSecond: 'Decrement Second',
			togglePeriod: 'Toggle Period',
			selectTime: 'Select Time'
		},
		useStrict: false,
		sideBySide: false,
		daysOfWeekDisabled: false,
		calendarWeeks: false,
		viewMode: 'days',
		toolbarPlacement: 'default',
		showTodayButton: false,
		showClear: false,
		showClose: false,
		widgetPositioning: {
			horizontal: 'auto',
			vertical: 'auto'
		},
		widgetParent: null,
		ignoreReadonly: false,
		keepOpen: false,
		focusOnShow: true,
		inline: false,
		keepInvalid: false,
		datepickerInput: '.datepickerinput',
		keyBinds: {
			up: function (widget) {
				if (!widget) {
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().subtract(7, 'd'));
				} else {
					this.date(d.clone().add(this.stepping(), 'm'));
				}
			},
			down: function (widget) {
				if (!widget) {
					this.show();
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().add(7, 'd'));
				} else {
					this.date(d.clone().subtract(this.stepping(), 'm'));
				}
			},
			'control up': function (widget) {
				if (!widget) {
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().subtract(1, 'y'));
				} else {
					this.date(d.clone().add(1, 'h'));
				}
			},
			'control down': function (widget) {
				if (!widget) {
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().add(1, 'y'));
				} else {
					this.date(d.clone().subtract(1, 'h'));
				}
			},
			left: function (widget) {
				if (!widget) {
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().subtract(1, 'd'));
				}
			},
			right: function (widget) {
				if (!widget) {
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().add(1, 'd'));
				}
			},
			pageUp: function (widget) {
				if (!widget) {
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().subtract(1, 'M'));
				}
			},
			pageDown: function (widget) {
				if (!widget) {
					return;
				}
				var d = this.date() || this.getMoment();
				if (widget.find('.datepicker').is(':visible')) {
					this.date(d.clone().add(1, 'M'));
				}
			},
			enter: function () {
				this.hide();
			},
			escape: function () {
				this.hide();
			},
			//tab: function (widget) { //this break the flow of the form. disabling for now
			//    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
			//    if(toggle.length > 0) toggle.click();
			//},
			'control space': function (widget) {
				if (widget.find('.timepicker').is(':visible')) {
					widget.find('.btn[data-action="togglePeriod"]').click();
				}
			},
			t: function () {
				this.date(this.getMoment());
			},
			'delete': function () {
				this.clear();
			}
		},
		debug: false,
		allowInputToggle: false,
		disabledTimeIntervals: false,
		disabledHours: false,
		enabledHours: false,
		viewDate: false
	};
}));